(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6916],{

/***/ 47050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37213);
/* harmony import */ var utils_securitiesLocalStorage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11763);




var onRequest = function(config) {
    var method = config.method, headers = config.headers, url = config.url, data = config.data;
    var securitiesRefreshToken = utils_securitiesLocalStorage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getSecuritiesToken */ .Z.getSecuritiesToken().securitiesRefreshToken;
    var isPostRequest = method === "POST" || method === "post";
    var isTradingAPI = url.includes(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL */ .Cb) || url[0] === "/";
    headers.Authorization = headers.Authorization || "Bearer ".concat(securitiesRefreshToken);
    if (isPostRequest && isTradingAPI) {
        headers["content-type"] = "application/x-www-form-urlencoded";
        // eslint-disable-next-line no-param-reassign
        config.data = qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(data);
    }
    return config;
};
var requestRefreshTrading = function() {
    var baseURL = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL */ .Cb;
    var apiInstance = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
        baseURL: baseURL,
        headers: {
            accept: "application/json"
        }
    });
    apiInstance.interceptors.request.use(function(config) {
        return onRequest(config);
    });
    return apiInstance;
};
/* harmony default export */ __webpack_exports__["Z"] = (requestRefreshTrading);


/***/ }),

/***/ 22537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bf": function() { return /* binding */ handleNoResponse; },
  "Ye": function() { return /* binding */ handleShowAlertMessage; },
  "vc": function() { return /* binding */ tradingErrorStatusHandlerList; }
});

// UNUSED EXPORTS: badRequestHandlerList, dispatchSetErrorCode, forbiddenErrorList, handleBadRequest, handleBondsError, handleForbidden, handleInternalServerError, handleRefreshToken, handleServiceUnavailable, handleSetErrorCode, handleUnauthorized, internalServerErrorHandlerList, serviceUnavailableHandlerList, unauthorizedHandlerList

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/lib/stores/trading.ts
var trading = __webpack_require__(76260);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/utils/securitiesLocalStorage.ts + 1 modules
var securitiesLocalStorage = __webpack_require__(11763);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/features/securities/utils.tsx
var utils = __webpack_require__(4621);
;// CONCATENATED MODULE: ./src/global/Securities/utils/apiBaseUrl.ts


var getSecuritiesAPIUrl = function() {
    return (0,utils/* isRedirectToNewCore */.JI)() ? api/* API_TRADING_URL_V2 */.cu : api/* API_TRADING_URL */.Cb;
};

// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/config/requestRefreshTrading.tsx
var requestRefreshTrading = __webpack_require__(47050);
;// CONCATENATED MODULE: ./src/global/Securities/api/instance/refresh.ts

var refreshApiInstance = (0,requestRefreshTrading/* default */.Z)();

;// CONCATENATED MODULE: ./src/global/Securities/api/auth.ts





var postAuthRefresh = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, axiosData;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return refreshApiInstance.post("".concat(getSecuritiesAPIUrl()).concat(apiEndpoint/* authEndpoint.authRefresh */.KQ.authRefresh));
                case 2:
                    ref = _ctx.sent;
                    axiosData = ref.data;
                    return _ctx.abrupt("return", axiosData.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postAuthRefresh() {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/constants.ts
var constants = __webpack_require__(38875);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondError.ts
var useBondError = __webpack_require__(10893);
// EXTERNAL MODULE: ./src/config/requestTrading/utils.ts
var requestTrading_utils = __webpack_require__(68481);
;// CONCATENATED MODULE: ./src/config/requestTrading/errorHandler.ts













// #region error type handler
var dispatchSetErrorCode = function(param) {
    var status = param.status, message = param.message, type = param.type;
    trading/* default.getState */.Z.getState().setErrorCode(status, message, type);
};
var handleSetErrorCode = function(error) {
    var errorConfig = (0,requestTrading_utils/* getErrorConfig */.v)(error);
    dispatchSetErrorCode(errorConfig);
    return Promise.reject(error);
};
var handleNoResponse = function(error) {
    dispatchSetErrorCode({
        status: 500
    });
    return Promise.reject(error);
};
var handleShowAlertMessage = function(error, message, isShowAlertMessage) {
    var errorConfig = (0,requestTrading_utils/* getErrorConfig */.v)(error);
    if ((message || errorConfig.message) && isShowAlertMessage) {
        (0,AlertMessage/* default */.Z)({
            content: message || errorConfig.message,
            alertType: "plain-default",
            messageType: "error",
            hasCloseIcon: false
        });
    }
    dispatchSetErrorCode(errorConfig);
    return Promise.reject(error);
};
var handleBondsError = function(error) {
    var errorConfig = (0,requestTrading_utils/* getErrorConfig */.v)(error);
    var bondBlockerType = constants/* bondsErrorTypesMapping */.eM[errorConfig.type] || constants/* BondBlockerType.UNSPECIFIED */.Ew.UNSPECIFIED;
    if (bondBlockerType === constants/* BondBlockerType.UNSPECIFIED */.Ew.UNSPECIFIED && errorConfig.message) {
        (0,AlertMessage/* default */.Z)({
            content: errorConfig.message,
            alertType: "plain-default",
            messageType: "error",
            hasCloseIcon: false
        });
        return Promise.reject(error);
    }
    useBondError/* default.getState */.Z.getState().setErrorCode(400, errorConfig.message, errorConfig.type);
    return Promise.reject(error);
};
var badRequestHandlerList = {
    // Bonds Error handlers
    product_not_found: handleBondsError,
    price_rate_not_found: handleBondsError,
    fr_in_record_date_period: handleBondsError,
    fr_bonds_market_close: handleBondsError,
    stockbit_get_account_not_found: handleBondsError,
    trading_account_suspended: handleBondsError,
    price_has_changed: handleBondsError,
    fr_existing_order_inprogress: handleBondsError,
    portfolio_not_exist: handleBondsError,
    redeem_amount_greater_than_redeemable_amount: handleBondsError,
    not_in_secondary_market_period: handleBondsError,
    sell_order_inprogress: handleBondsError,
    user_sharia_validation: handleBondsError,
    stable_earn_cannot_be_sold_outside_bibit: handleBondsError
};
var unauthorizedHandlerList = {
    INVALID_AUTH: handleSetErrorCode,
    INVALID_TOKEN: handleSetErrorCode,
    INVALID_SESSION: handleSetErrorCode,
    MOCK_TRADING: handleSetErrorCode,
    MAINTENANCE_MODE: handleSetErrorCode,
    DAILY_MAINTENANCE_MODE: handleSetErrorCode,
    INVALID_CREDS: handleSetErrorCode,
    UNAUTHORIZED: handleSetErrorCode
};
var forbiddenErrorList = {
    USER_SUSPEND: handleSetErrorCode,
    USER_SUSPEND_BACK_OFFICE: handleSetErrorCode,
    FORBIDDEN: handleSetErrorCode
};
var serviceUnavailableHandlerList = {
    DAILY_MAINTENANCE_MODE: handleSetErrorCode,
    MAINTENANCE_MODE: handleSetErrorCode
};
var internalServerErrorHandlerList = {
    SYSTEM_ERROR: handleSetErrorCode
};
// #endregion error type handler
// #region Status Handler
var handleRefreshToken = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(error) {
        var ref, currentRefreshToken, ref1, accessToken, refreshToken;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ref = securitiesLocalStorage/* default.getSecuritiesToken */.Z.getSecuritiesToken(), currentRefreshToken = ref.securitiesRefreshToken;
                    if (currentRefreshToken) {
                        _ctx.next = 4;
                        break;
                    }
                    throw new Error("Securities refresh token is not exists");
                case 4:
                    _ctx.next = 6;
                    return postAuthRefresh();
                case 6:
                    ref1 = _ctx.sent;
                    accessToken = ref1.access_token;
                    refreshToken = ref1.refresh_token;
                    securitiesLocalStorage/* default.saveSecuritiesToken */.Z.saveSecuritiesToken({
                        securitiesAccessToken: accessToken,
                        securitiesRefreshToken: refreshToken
                    });
                    return _ctx.abrupt("return", axios_default().request((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, error.config), {
                        headers: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, error.config.headers), {
                            Authorization: "Bearer ".concat(accessToken)
                        })
                    })).catch(function(refreshError) {
                        handleSetErrorCode(refreshError);
                        return Promise.reject(refreshError);
                    }));
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    handleSetErrorCode(error);
                    return _ctx.abrupt("return", Promise.reject(error));
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return function handleRefreshToken(error) {
        return _ref.apply(this, arguments);
    };
}();
var handleBadRequest = function(error) {
    var isShowAlertMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var type = (0,requestTrading_utils/* getErrorConfig */.v)(error).type;
    var errorHandler = badRequestHandlerList[type];
    if (errorHandler) return errorHandler(error);
    if (isShowAlertMessage) handleShowAlertMessage(error);
    return Promise.reject(error);
};
var handleUnauthorized = function(error) {
    if (!error.response.data) return handleRefreshToken(error);
    var type = (0,requestTrading_utils/* getErrorConfig */.v)(error).type;
    var errorHandler = unauthorizedHandlerList[type];
    if (errorHandler) return errorHandler(error);
    handleShowAlertMessage(error);
    return Promise.reject(error);
};
var handleForbidden = function(error) {
    if (!error.response.data) return handleRefreshToken(error);
    var type = (0,requestTrading_utils/* getErrorConfig */.v)(error).type;
    var errorHandler = forbiddenErrorList[type];
    if (errorHandler) return errorHandler(error);
    return Promise.reject(error);
};
var handleServiceUnavailable = function(error) {
    var type = (0,requestTrading_utils/* getErrorConfig */.v)(error).type;
    var errorHandler = serviceUnavailableHandlerList[type];
    if (errorHandler) return errorHandler(error);
    handleShowAlertMessage(error, errorMessage/* default.UNKNOWN_SYSTEM_ERROR */.Z.UNKNOWN_SYSTEM_ERROR);
    return Promise.reject(error);
};
var handleInternalServerError = function(error) {
    var type = (0,requestTrading_utils/* getErrorConfig */.v)(error).type;
    var errorHandler = internalServerErrorHandlerList[type];
    if (errorHandler) return errorHandler(error);
    handleShowAlertMessage(error, errorMessage/* default.UNKNOWN_SYSTEM_ERROR */.Z.UNKNOWN_SYSTEM_ERROR);
    return Promise.reject(error);
};
// Refer here for function naming
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Status
var tradingErrorStatusHandlerList = {
    400: handleBadRequest,
    401: handleUnauthorized,
    403: handleForbidden,
    503: handleServiceUnavailable,
    500: handleInternalServerError
}; // #endregion Status Handler


/***/ }),

/***/ 48884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ requestTrading; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/utils/securitiesLocalStorage.ts + 1 modules
var securitiesLocalStorage = __webpack_require__(11763);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
// EXTERNAL MODULE: ./src/config/requestTrading/errorHandler.ts + 3 modules
var errorHandler = __webpack_require__(22537);
// EXTERNAL MODULE: ./src/config/requestTrading/utils.ts
var utils = __webpack_require__(68481);
;// CONCATENATED MODULE: ./src/config/requestTrading/constants.ts
var CUSTOM_HIDDEN_ALERT_URL = [
    "auth/pin/validate",
    "auth/v2/pin/change/new",
    "auth/v2/pin/change/confirm",
    "auth/v2/pin/reset/new",
    "auth/v2/pin/reset/confirm", 
];

;// CONCATENATED MODULE: ./src/config/requestTrading/index.ts
/* eslint-disable consistent-return */ 




// constact

// handler





var onRequest = function(config, urlEncoded) {
    var securitiesAccessToken = securitiesLocalStorage/* default.getSecuritiesToken */.Z.getSecuritiesToken().securitiesAccessToken;
    var method = config.method, headers = config.headers, url = config.url, data = config.data, _withAccessToken = config.withAccessToken, withAccessToken = _withAccessToken === void 0 ? true : _withAccessToken;
    // assign access token
    if (securitiesAccessToken && withAccessToken) {
        headers.Authorization = "Bearer ".concat(securitiesAccessToken);
    }
    // immidiately return the config if using the new trading API
    var isTradingAPIV2 = url.includes(api/* API_TRADING_URL_V2 */.cu); // `/`
    if (isTradingAPIV2) {
        return config;
    }
    /**
   * @deprecated
   * we check wether the request is from the legacy API_TRADING_URL
   */ var isLegacyTradingAPI = url.includes(api/* API_TRADING_URL */.Cb);
    /**
   * @deprecated
   * we check wether the request using POST (post) method
   */ var isPostRequest = method === "POST" || method === "post";
    /**
   * @deprecated
   * Check if user is using the legacy API,
   * We will override the content-type header config
   */ if (isLegacyTradingAPI && isPostRequest || urlEncoded) {
        headers["content-type"] = "application/x-www-form-urlencoded";
        // eslint-disable-next-line no-param-reassign
        config.data = lib_default().stringify(data);
    }
    return config;
};
var onResponseError = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(error, isShowAlertMessage) {
        var ref, ref1, ref2, ref3, response, request, status, apiUrl, isNoNeedToRefreshToken, isHideAlertOnCustomUrl, statusHandler;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    response = error.response, request = error.request;
                    status = (0,utils/* getErrorConfig */.v)(error).status;
                    (0,logger/* sentryLog */.gB)({
                        scope: "server-layer",
                        level: "error",
                        httpStatusCode: status,
                        tags: [
                            {
                                title: "api-error-url",
                                value: request === null || request === void 0 ? void 0 : request.responseURL
                            },
                            {
                                title: "api-error-text",
                                value: request === null || request === void 0 ? void 0 : request.responseText
                            }, 
                        ],
                        error: error
                    });
                    if (!(!response && isShowAlertMessage)) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return", (0,errorHandler/* handleNoResponse */.bf)(error));
                case 6:
                    if (!(status === 401 && (request === null || request === void 0 ? void 0 : (ref = request.responseURL) === null || ref === void 0 ? void 0 : ref.includes("auth/logout")))) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", Promise.reject(error));
                case 8:
                    apiUrl = (0,utils/* getPathFromUrl */.j)((ref1 = error.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.config) === null || ref2 === void 0 ? void 0 : ref2.url) || "";
                    isNoNeedToRefreshToken = status !== 401 && ((ref3 = error.response) === null || ref3 === void 0 ? void 0 : ref3.data);
                    isHideAlertOnCustomUrl = CUSTOM_HIDDEN_ALERT_URL.includes(apiUrl);
                    if (!(!isShowAlertMessage && isHideAlertOnCustomUrl && isNoNeedToRefreshToken)) {
                        _ctx.next = 13;
                        break;
                    }
                    return _ctx.abrupt("return", Promise.reject(error));
                case 13:
                    statusHandler = errorHandler/* tradingErrorStatusHandlerList */.vc[status];
                    if (!statusHandler) {
                        _ctx.next = 16;
                        break;
                    }
                    return _ctx.abrupt("return", statusHandler(error, isShowAlertMessage));
                case 16:
                    return _ctx.abrupt("return", (0,errorHandler/* handleShowAlertMessage */.Ye)(error, "", isShowAlertMessage));
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function onResponseError(error, isShowAlertMessage) {
        return _ref.apply(this, arguments);
    };
}();
var request = function() {
    var baseURL = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : api/* API_TRADING_URL */.Cb, isShowAlertMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, urlEncoded = arguments.length > 2 ? arguments[2] : void 0, customHeaders = arguments.length > 3 ? arguments[3] : void 0;
    var headers = {
        accept: "application/json"
    };
    if (customHeaders) headers = (0,_object_spread/* default */.Z)({}, headers, customHeaders);
    var apiInstance = axios_default().create({
        baseURL: baseURL,
        headers: headers
    });
    apiInstance.interceptors.request.use(function(config) {
        return onRequest(config, urlEncoded);
    });
    apiInstance.interceptors.response.use(function(response) {
        return response;
    }, function(error) {
        return onResponseError(error, isShowAlertMessage);
    });
    return apiInstance;
};
/* harmony default export */ var requestTrading = (request);


/***/ }),

/***/ 68481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ getPathFromUrl; },
/* harmony export */   "v": function() { return /* binding */ getErrorConfig; }
/* harmony export */ });
var getErrorConfig = function(error) {
    var ref = error.response || {}, data = ref.data, status = ref.status;
    var ref1 = data || {}, type = ref1.error_type, message = ref1.message;
    return {
        status: status,
        type: type,
        message: message
    };
};
var getPathFromUrl = function(url) {
    try {
        var urlObj = new URL(url);
        var pathname = urlObj.pathname;
        var pathParts = pathname.replace(/^\/+|\/+$/g, "").split("/");
        return pathParts.join("/");
    } catch (error) {
        return null;
    }
};


/***/ }),

/***/ 92124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Av": function() { return /* binding */ DAY_TRADE_ACTIVATION_SELECTED; },
/* harmony export */   "B": function() { return /* binding */ STOCK_SELECTED; },
/* harmony export */   "BY": function() { return /* binding */ DAY_TRADE_ORDER_DETAIL_SELECTED; },
/* harmony export */   "CV": function() { return /* binding */ DAY_TRADE_SPLIT_ORDER_SELECTED; },
/* harmony export */   "D1": function() { return /* binding */ DAY_TRADE_ALERT_AFTER_MARKET_VIEWED; },
/* harmony export */   "DQ": function() { return /* binding */ DAY_TRADE_ACTIVATION_SUCCESS_VIEWED; },
/* harmony export */   "Dn": function() { return /* binding */ EXERCISE_ORDER_CONFIRMED; },
/* harmony export */   "E": function() { return /* binding */ AMEND_ORDER_CONFIRMED; },
/* harmony export */   "G2": function() { return /* binding */ DAY_TRADE_SET_VISIBLE_BALANCE; },
/* harmony export */   "GK": function() { return /* binding */ DAY_TRADE_STOCK_LIST_VIEWED; },
/* harmony export */   "Go": function() { return /* binding */ DAY_TRADE_ACTIVATION_SUCCESS_SELECTED; },
/* harmony export */   "HA": function() { return /* binding */ BUY_ORDER_VIEWED; },
/* harmony export */   "HM": function() { return /* binding */ AUTO_BUY_ACTION; },
/* harmony export */   "Hb": function() { return /* binding */ AMEND_ORDER_PREVIEWED; },
/* harmony export */   "Hd": function() { return /* binding */ SECURITIES_TRADING_PIN_VIEWED; },
/* harmony export */   "Hm": function() { return /* binding */ BUY_ORDER_RECEIVED; },
/* harmony export */   "II": function() { return /* binding */ SECURITIES_TRADING_PIN_SUBMITTED; },
/* harmony export */   "IU": function() { return /* binding */ BUY_ERROR_PAGE; },
/* harmony export */   "J1": function() { return /* binding */ PORTFOLIO_VIEW_CHART_SELECTED; },
/* harmony export */   "JW": function() { return /* binding */ PORTFOLIO_COMPANY_SELL_STOCK_SELECTED; },
/* harmony export */   "L7": function() { return /* binding */ DAY_TRADE_LEVERAGE_SELECTED; },
/* harmony export */   "L9": function() { return /* binding */ BUY_ORDER_PREVIEWED; },
/* harmony export */   "LD": function() { return /* binding */ SELL_ORDER_CONFIRMED_SUCCESS; },
/* harmony export */   "Le": function() { return /* binding */ ORDER_DETAIL_CANCEL_ORDER_SELECTED; },
/* harmony export */   "Nq": function() { return /* binding */ EXERCISE_SELECTED; },
/* harmony export */   "O9": function() { return /* binding */ AMEND_ORDER_DONE; },
/* harmony export */   "Oc": function() { return /* binding */ SECURITIES_ORDER_TAB_SELECTED; },
/* harmony export */   "TC": function() { return /* binding */ DAY_TRADE_LEVERAGE_ACTIVATION_SELECTED; },
/* harmony export */   "Tf": function() { return /* binding */ ORDER_DETAIL_CANCEL_ORDER_VIEWED; },
/* harmony export */   "Vm": function() { return /* binding */ EXERCISE_ERROR_PAGE; },
/* harmony export */   "YB": function() { return /* binding */ DAY_TRADE_ORDER_TYPE_SELECTED; },
/* harmony export */   "YM": function() { return /* binding */ DAY_TRADE_STOCK_SORT_VIEWED; },
/* harmony export */   "YS": function() { return /* binding */ SECURITIES_AUTO_ORDER_OPTIONS_VIEWED; },
/* harmony export */   "Yu": function() { return /* binding */ DAY_TRADE_ALERT_DEBT_RATIO_SUBMITTED; },
/* harmony export */   "ZF": function() { return /* binding */ SELL_ORDER_CONFIRMED; },
/* harmony export */   "ZN": function() { return /* binding */ AMEND_ORDER_RECEIVED; },
/* harmony export */   "Zy": function() { return /* binding */ DAY_TRADE_SORT_APPLIED; },
/* harmony export */   "_O": function() { return /* binding */ PORTFOLIO_BUY_MORE_SELECTED; },
/* harmony export */   "_e": function() { return /* binding */ EXCHANGE_FEE_VIEWED; },
/* harmony export */   "_g": function() { return /* binding */ PORTFOLIO_EXERCISE_CLICKED; },
/* harmony export */   "a": function() { return /* binding */ EXERCISE_ORDER_CANCELED; },
/* harmony export */   "bK": function() { return /* binding */ DAY_TRADE_DEBT_RATIO_MODAL_VIEWED; },
/* harmony export */   "bt": function() { return /* binding */ DAY_TRADE_ACTION; },
/* harmony export */   "cG": function() { return /* binding */ AMEND_ORDER_PLACED; },
/* harmony export */   "cc": function() { return /* binding */ DAY_TRADE_SORT_SELECTED; },
/* harmony export */   "dR": function() { return /* binding */ CLEVERTAP_EVENT_NAME; },
/* harmony export */   "dT": function() { return /* binding */ SELL_ORDER_CANCELED; },
/* harmony export */   "dW": function() { return /* binding */ EXERCISE_VIEWED; },
/* harmony export */   "dz": function() { return /* binding */ ORDER_VIEWED; },
/* harmony export */   "ee": function() { return /* binding */ BUY_ORDER_CONFIRMED; },
/* harmony export */   "ef": function() { return /* binding */ PORTFOLIO_SET_PRICE_ALERT_SELECTED; },
/* harmony export */   "fR": function() { return /* binding */ ORDER_DETAIL_CANCEL_ORDER_CONFIRMED; },
/* harmony export */   "fg": function() { return /* binding */ ORDER_DETAIL_AMEND_SELECTED; },
/* harmony export */   "g1": function() { return /* binding */ BUY_ORDER_DONE; },
/* harmony export */   "gE": function() { return /* binding */ SELL_ORDER_VIEWED; },
/* harmony export */   "gW": function() { return /* binding */ BUY_ORDER_QUANTITY_ADJUSTED; },
/* harmony export */   "gg": function() { return /* binding */ BUY_ORDER_PLACED; },
/* harmony export */   "hG": function() { return /* binding */ DAY_TRADE_TNC_VIEWED; },
/* harmony export */   "iW": function() { return /* binding */ AMEND_ORDER_CANCELED; },
/* harmony export */   "jG": function() { return /* binding */ EXERCISE_ORDER_PREVIEWED; },
/* harmony export */   "jY": function() { return /* binding */ DAY_TRADE_ACTIVATION_VIEWED; },
/* harmony export */   "jr": function() { return /* binding */ CHANGE_STOCK_VIEWED; },
/* harmony export */   "kC": function() { return /* binding */ PORTFOLIO_STOCK_DETAIL_VIEWED; },
/* harmony export */   "lE": function() { return /* binding */ BUY_ORDER_CANCELED; },
/* harmony export */   "lK": function() { return /* binding */ AMEND_ORDER_QUANTITY_ADJUSTED; },
/* harmony export */   "le": function() { return /* binding */ PORTFOLIO_DETAIL_EXERCISE_SELECTED; },
/* harmony export */   "mX": function() { return /* binding */ DAY_TRADE_ACTIVATION_SUBMITTED; },
/* harmony export */   "n2": function() { return /* binding */ SELL_ORDER_RECEIVED; },
/* harmony export */   "nc": function() { return /* binding */ DAY_TRADE_ALERT_DEBT_RATIO_VIEWED; },
/* harmony export */   "p3": function() { return /* binding */ BUY_ORDER_CONFIRMED_SUCCESS; },
/* harmony export */   "q7": function() { return /* binding */ SELL_ORDER_PREVIEWED; },
/* harmony export */   "sR": function() { return /* binding */ SELL_ORDER_QUANTITY_ADJUSTED; },
/* harmony export */   "tA": function() { return /* binding */ PORTFOLIO_VIEWED; },
/* harmony export */   "tI": function() { return /* binding */ EXCHANGE_FEE_SELECTED; },
/* harmony export */   "v9": function() { return /* binding */ ORDER_DETAIL_VIEWED; },
/* harmony export */   "vc": function() { return /* binding */ SELL_ORDER_PLACED; },
/* harmony export */   "vf": function() { return /* binding */ PORTFOLIO_SELL_STOCK_SELECTED; },
/* harmony export */   "wK": function() { return /* binding */ DAY_TRADE_ACTIVATION_DISMISSED; },
/* harmony export */   "xc": function() { return /* binding */ SELL_ORDER_DONE; },
/* harmony export */   "z8": function() { return /* binding */ AMEND_ORDER_VIEWED; },
/* harmony export */   "zF": function() { return /* binding */ PORTFOLIO_ORDER_VIEWED; },
/* harmony export */   "zW": function() { return /* binding */ DAY_TRADE_LEVERAGE_OPTION_VIEWED; },
/* harmony export */   "zt": function() { return /* binding */ DAY_TRADE_DEBT_RATIO_CHIP_SELECTED; }
/* harmony export */ });
/* unused harmony exports TRANSACTION_ORDER_FAILED, TRANSACTION_ORDER_FAILED_CONFIRMED, TRANSACTION_ORDER_ALERT, BUY_STOCK_CONTINUE */
var CLEVERTAP_EVENT_NAME = {
    SIDE_MENU: "side_menu_action",
    HEADER_MENU: "header_menu_action",
    COMPANY_MENU: "company_action"
};
// List of stockbit securities clevertap event name
// https://www.notion.so/stockbit/Stockbit-Buy-Sell-Order-Web-e129c61e0ae64d70abdb0d1811c5ec71
/// //////// Cancel Order and Amend Event ///////////
var ORDER_DETAIL_CANCEL_ORDER_SELECTED = "Order Detail Cancel Order Selected";
var ORDER_DETAIL_CANCEL_ORDER_VIEWED = "Order Detail Cancel Order Viewed";
var ORDER_DETAIL_CANCEL_ORDER_CONFIRMED = "Order Detail Cancel Order Confirmed";
var ORDER_DETAIL_AMEND_SELECTED = "Order Detail Amend Selected";
var AMEND_ORDER_VIEWED = "Amend Order Viewed";
var AMEND_ORDER_QUANTITY_ADJUSTED = "Amend Order Quantity Adjusted";
var AMEND_ORDER_PLACED = "Amend Order Placed";
var AMEND_ORDER_PREVIEWED = "Amend Order Previewed";
var AMEND_ORDER_CANCELED = "Amend Order Canceled";
var AMEND_ORDER_CONFIRMED = "Amend Order Confirmed";
var AMEND_ORDER_RECEIVED = "Amend Order Received";
var AMEND_ORDER_DONE = "Amend Order Done";
/// //////// Buy Order Event ///////////
var BUY_ORDER_QUANTITY_ADJUSTED = "Buy Order Quantity Adjusted";
var BUY_ORDER_PLACED = "Buy Order Placed";
var BUY_ORDER_PREVIEWED = "Buy Order Previewed";
var BUY_ORDER_VIEWED = "Buy Order Viewed";
var BUY_ORDER_CANCELED = "Buy Order Canceled";
var BUY_ORDER_CONFIRMED = "Buy Order Confirmed";
var BUY_ORDER_RECEIVED = "Buy Order Received";
var BUY_ORDER_DONE = "Buy Order Done";
var BUY_ERROR_PAGE = "Buy Error Page";
var CHANGE_STOCK_VIEWED = "Change Stock Viewed";
var PORTFOLIO_BUY_MORE_SELECTED = "Portfolio Buy More Selected";
var BUY_ORDER_CONFIRMED_SUCCESS = "Success Buy Order Confirmed";
/// //////// Sell Order Event ///////////
var SELL_ORDER_QUANTITY_ADJUSTED = "Sell Order Quantity Adjusted";
var SELL_ORDER_PLACED = "Sell Order Placed";
var SELL_ORDER_PREVIEWED = "Sell Order Previewed";
var SELL_ORDER_VIEWED = "Sell Order Viewed";
var SELL_ORDER_CANCELED = "Sell Order Canceled";
var SELL_ORDER_CONFIRMED = "Sell Order Confirmed";
var SELL_ORDER_RECEIVED = "Sell Order Received";
var SELL_ORDER_DONE = "Sell Order Done";
var SELL_ORDER_CONFIRMED_SUCCESS = "Success Sell Order Confirmed";
/// //////// Exchange Fee Event ///////////
var EXCHANGE_FEE_SELECTED = "Exchange Fee Selected";
var EXCHANGE_FEE_VIEWED = "Exchange Fee Viewed";
/// //////// Portfolio Event ///////////
var PORTFOLIO_VIEWED = "Portfolio Viewed";
var PORTFOLIO_ORDER_VIEWED = "Portfolio Order Viewed";
var PORTFOLIO_SELL_STOCK_SELECTED = "Portfolio Sell Stock Selected";
var PORTFOLIO_COMPANY_SELL_STOCK_SELECTED = "Company Sell Stock Selected";
var PORTFOLIO_STOCK_DETAIL_VIEWED = "Portfolio Stock Detail Viewed";
/// //////// Order List Page Event ///////////
var ORDER_VIEWED = "Order viewed";
var ORDER_DETAIL_VIEWED = "Order Detail Viewed";
var STOCK_SELECTED = "Stock Selected";
/// //////// Order Exercise Event ///////////
var PORTFOLIO_EXERCISE_CLICKED = "Portfolio Exercise Clicked";
var PORTFOLIO_DETAIL_EXERCISE_SELECTED = "Portfolio Detail Exercise Selected";
var EXERCISE_VIEWED = "Exercise Viewed";
var EXERCISE_SELECTED = "Exercise Selected";
var EXERCISE_ERROR_PAGE = "Exercise Error Page";
var EXERCISE_ORDER_PREVIEWED = "Exercise Order Previewed";
var EXERCISE_ORDER_CONFIRMED = "Exercise Order Confirmed";
var EXERCISE_ORDER_CANCELED = "Exercise Order Canceled";
var TRANSACTION_ORDER_FAILED = "Transaction Order Failed";
var TRANSACTION_ORDER_FAILED_CONFIRMED = "Transaction Order Failed Confirmed";
var TRANSACTION_ORDER_ALERT = "Transaction Order Alert";
var BUY_STOCK_CONTINUE = "Buy Stock Continue";
/// //////// Chart Event ///////////
var PORTFOLIO_VIEW_CHART_SELECTED = "Portfolio View Chart Selected";
var PORTFOLIO_SET_PRICE_ALERT_SELECTED = "Portfolio Set Price Alert Selected";
/// //////// Day Trade Event ///////////
var DAY_TRADE_ACTION = "Day Trade Action";
var AUTO_BUY_ACTION = "Auto Buy Action";
var DAY_TRADE_ACTIVATION_VIEWED = "Day Trade Activation Viewed";
var DAY_TRADE_TNC_VIEWED = "Tnc Day Trade Viewed";
var DAY_TRADE_ACTIVATION_SUCCESS_VIEWED = "Success Activated Day Trade Viewed";
var DAY_TRADE_ACTIVATION_SELECTED = "Day Trade Activated Now Selected";
var DAY_TRADE_ACTIVATION_DISMISSED = "Day Trade Activated Later Selected";
var DAY_TRADE_ACTIVATION_SUBMITTED = "TnC Day Trade Lanjut Selected";
var DAY_TRADE_ACTIVATION_SUCCESS_SELECTED = "Day Trade Success Activated Selected";
var DAY_TRADE_LEVERAGE_OPTION_VIEWED = "Balance Setting Viewed";
var DAY_TRADE_LEVERAGE_ACTIVATION_SELECTED = "Day Trade Aktifkan Selected";
var DAY_TRADE_ALERT_AFTER_MARKET_VIEWED = "Alert After Hour Day Trade Viewed";
var DAY_TRADE_ALERT_DEBT_RATIO_VIEWED = "Alert Force Sell Day Trade Viewed";
var DAY_TRADE_ALERT_DEBT_RATIO_SUBMITTED = "Alert Force Sell Day Trade Selected";
var DAY_TRADE_DEBT_RATIO_CHIP_SELECTED = "Debt Ratio Selected";
var DAY_TRADE_DEBT_RATIO_MODAL_VIEWED = "Debt Ratio Viewed";
var DAY_TRADE_STOCK_LIST_VIEWED = "Day Trade List Viewed";
var DAY_TRADE_STOCK_SORT_VIEWED = "Day Trade Sort By Viewed";
var DAY_TRADE_LEVERAGE_SELECTED = "Set Leverage Selected";
var DAY_TRADE_SORT_SELECTED = "Sort By Day Trade Selected";
var DAY_TRADE_SORT_APPLIED = "Apply Sort Day Trade";
var DAY_TRADE_ORDER_TYPE_SELECTED = "Auto Buy Order Type Selected";
var DAY_TRADE_SPLIT_ORDER_SELECTED = "Split Order Toggle Selected";
var DAY_TRADE_ORDER_DETAIL_SELECTED = "Order Detail Selected";
var DAY_TRADE_SET_VISIBLE_BALANCE = "Set Visible Balance";
var SECURITIES_TRADING_PIN_VIEWED = "Trading PIN Login Page Viewed";
var SECURITIES_TRADING_PIN_SUBMITTED = "Trading PIN Loggen In";
var SECURITIES_AUTO_ORDER_OPTIONS_VIEWED = "Auto Buy Order Type Viewed";
var SECURITIES_ORDER_TAB_SELECTED = "Order Transaction Type Selected";


/***/ }),

/***/ 83153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Do": function() { return /* binding */ CORPORATE_ACTION_STOCK_TYPE; },
/* harmony export */   "FA": function() { return /* binding */ UserTargetAPI; },
/* harmony export */   "Ik": function() { return /* binding */ LOT_ORDER_LIMIT; },
/* harmony export */   "Jm": function() { return /* binding */ ORDER_TYPE; },
/* harmony export */   "L2": function() { return /* binding */ STOCK_TYPE; },
/* harmony export */   "PX": function() { return /* binding */ ORDER_STATUS_COLOR; },
/* harmony export */   "cD": function() { return /* binding */ ORDER_EXPIRY_TEXT; },
/* harmony export */   "dB": function() { return /* binding */ CorporateActionStockType; },
/* harmony export */   "pr": function() { return /* binding */ SPLIT_ORDER_LOT; },
/* harmony export */   "x4": function() { return /* binding */ BUY_ORDER_TYPE_TEXT; }
/* harmony export */ });
/* unused harmony exports BOARD_TYPE, DEPOSIT_OTHER_BANK_CODE */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var BOARD_TYPE = {
    saham: "RG",
    right: "TN"
};
var STOCK_TYPE = {
    saham: "saham",
    right: "right",
    waran: "waran",
    index: "index",
    index_asing: "index_asing",
    reksadana: "reksadana",
    commodities: "commodities",
    crypto: "crypto",
    fx: "fx",
    etf: "etf",
    bond: "bond"
};
var ORDER_TYPE = {
    BUY: "BUY",
    SELL: "SELL",
    AMEND_BUY: "AMEND_BUY",
    AMEND_SELL: "AMEND_SELL",
    EXERCISE: "EXERCISE",
    VIRTUAL_BUY: "VIRTUAL_BUY",
    VIRTUAL_SELL: "VIRTUAL_SELL",
    VIRTUAL_AMEND_BUY: "VIRTUAL_AMEND_BUY",
    VIRTUAL_AMEND_SELL: "VIRTUAL_AMEND_SELL",
    BOND: "BOND_TRANSACTION"
};
var ORDER_EXPIRY_TEXT = {
    gfd: "Good For Day",
    gtc: "Good Till Cancelled",
    gtcSixMonth: "Good Till Cancelled (6 Months)"
};
var BUY_ORDER_TYPE_TEXT = {
    LO: "Limit Order",
    AB: "Auto Buy"
};
var CORPORATE_ACTION_STOCK_TYPE = [
    "WARAN",
    "RIGHT",
    "ETF"
];
var DEPOSIT_OTHER_BANK_CODE = "999";
var ORDER_STATUS_COLOR = {
    order: {
        open: "#00ab6b",
        active: "#00ab6b",
        pending: "#00ab6b",
        ready: "#00ab6b",
        partial: "#00ab6b",
        "request amend": "#333333",
        amended: "#333333",
        "request cancel": "#333333",
        withdrawn: "#333333",
        match: "#333333",
        rejected: "#EE4A49"
    },
    exercise: {
        success: "#333333",
        processed: "#00ab6b",
        pending: "#00ab6b",
        rejected: "#EE4A49"
    }
};
var UserTargetAPI;
(function(UserTargetAPI) {
    UserTargetAPI["LEGACY"] = "1";
    UserTargetAPI["NEW_CORE"] = "2";
})(UserTargetAPI || (UserTargetAPI = {}));
var _obj;
var LOT_ORDER_LIMIT = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, "1", 999999), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, "2", 9999999), _obj);
var SPLIT_ORDER_LOT = 50000;
var CorporateActionStockType = [
    STOCK_TYPE.waran,
    STOCK_TYPE.right,
    STOCK_TYPE.etf, 
];


/***/ }),

/***/ 3683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ModalNames; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);

var ModalNames;
(function(ModalNames) {
    ModalNames["PORTFOLIO_ONBOARDING"] = "PORTFOLIO_ONBOARDING";
    ModalNames["PORTFOLIO_CREATE"] = "PORTFOLIO_CREATE";
    ModalNames["PORTFOLIO_CREATE_BLOCKED"] = "PORTFOLIO_CREATE_BLOCKED";
    ModalNames["PORTFOLIO_TNC"] = "PORTFOLIO_TNC";
    ModalNames["PORTFOLIO_SUCCESS"] = "PORTFOLIO_SUCCESS";
    ModalNames["PORTFOLIO_RENAME"] = "PORTFOLIO_RENAME";
    ModalNames["TRANSFER_SELECT"] = "TRASNFER_SELECT";
    ModalNames["TRANSFER_CASH"] = "TRANSFER_CASH";
    ModalNames["TRANSFER_CASH_CONFIRM"] = "TRANSFER_CASH_CONFIRM";
    ModalNames["TRANSFER_CASH_SUCCESS"] = "TRANSFER_CASH_SUCCESS";
    ModalNames["TRANSFER_CASH_BALANCE_REVIEW"] = "TRANSFER_CASH_BALANCE_REVIEW";
    ModalNames["TRANSFER_STOCK"] = "TRANSFER_STOCK";
    ModalNames["TRANSFER_STOCK_CONFIRM"] = "TRANSFER";
    ModalNames["TRANSFER_STOCK_SUCCESS"] = "TRANSFER_STOCK_SUCCESS";
})(ModalNames || (ModalNames = {}));
var useModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        activeModal: null,
        openModal: function(modalName) {
            return set({
                activeModal: modalName
            });
        },
        closeModal: function() {
            return set({
                activeModal: null
            });
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useModalStore);


/***/ }),

/***/ 4621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ai": function() { return /* binding */ getTargetAPI; },
/* harmony export */   "JI": function() { return /* binding */ isRedirectToNewCore; },
/* harmony export */   "TW": function() { return /* binding */ generateUiRef; },
/* harmony export */   "kk": function() { return /* binding */ getRoundDownValue; },
/* harmony export */   "yM": function() { return /* binding */ setTargetAPI; }
/* harmony export */ });
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83153);


var getTargetAPI = function() {
    if (!(0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) return constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .UserTargetAPI.LEGACY */ .FA.LEGACY;
    var target = localStorage.getItem("securitiesTarget");
    return target || constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .UserTargetAPI.LEGACY */ .FA.LEGACY;
};
var setTargetAPI = function() {
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .UserTargetAPI.LEGACY */ .FA.LEGACY;
    localStorage.setItem("securitiesTarget", target);
    return target;
};
var isRedirectToNewCore = function() {
    return getTargetAPI() === constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .UserTargetAPI.NEW_CORE */ .FA.NEW_CORE;
};
var generateUiRef = function() {
    var result = "";
    var length = 13;
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    var charactersLength = characters.length;
    // eslint-disable-next-line no-plusplus
    for(var i = 0; i < length; i++){
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return "W".concat(Date.now()).concat(result);
};
/**
 *
 * @param balanceValue - balance value number
 * @param fraction - fraction number
 * @returns
 * @example
 * getRoundDownValue(12345, 2) => 12345
 * getRoundDownValue(12345.6789, 2) => 12345.67
 * getRoundDownValue(12345.6789, 3) => 12345.678
 */ var getRoundDownValue = function(balanceValue, fraction) {
    var multiplier = Math.pow(10, fraction);
    var roundedValue = Math.floor(balanceValue * multiplier) / multiplier;
    var stringValue = balanceValue.toString();
    var decimalIndex = stringValue.indexOf(".");
    if (decimalIndex !== -1) {
        var truncatedValue = stringValue.slice(0, decimalIndex + fraction + 1);
        return parseFloat(truncatedValue);
    }
    return roundedValue;
};


/***/ }),

/***/ 78765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ BankAmendStatusEnums; },
/* harmony export */   "k": function() { return /* binding */ BalanceScopeEnum; }
/* harmony export */ });
var BankAmendStatusEnums;
(function(BankAmendStatusEnums) {
    BankAmendStatusEnums["AMEND_STATUS_UNSPECIFIED"] = "AMEND_STATUS_UNSPECIFIED";
    BankAmendStatusEnums["AMEND_STATUS_IN_PROGRESS"] = "AMEND_STATUS_IN_PROGRESS";
    BankAmendStatusEnums["AMEND_STATUS_REJECTED"] = "AMEND_STATUS_REJECTED";
    BankAmendStatusEnums["AMEND_STATUS_COMPLETED"] = "AMEND_STATUS_COMPLETED";
})(BankAmendStatusEnums || (BankAmendStatusEnums = {}));
var BalanceScopeEnum;
(function(BalanceScopeEnum) {
    BalanceScopeEnum["ALL_RELATED_ACCOUNT"] = "BALANCE_SCOPE_ALL_RELATED_ACCOUNT";
    BalanceScopeEnum["SELECTED_ACCOUNT"] = "BALANCE_SCOPE_SELECTED_ACCOUNT";
})(BalanceScopeEnum || (BalanceScopeEnum = {}));


/***/ }),

/***/ 53850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CI": function() { return /* binding */ emittenEndpoint; },
/* harmony export */   "Db": function() { return /* binding */ portfolioEndpoint; },
/* harmony export */   "EN": function() { return /* binding */ bondsEndpoints; },
/* harmony export */   "I6": function() { return /* binding */ orderbookEndpoint; },
/* harmony export */   "KQ": function() { return /* binding */ authEndpoint; },
/* harmony export */   "Li": function() { return /* binding */ orderEndpoint; },
/* harmony export */   "Lr": function() { return /* binding */ termsAndConditionsEndpoint; },
/* harmony export */   "b4": function() { return /* binding */ termsAndConditionsAPI; },
/* harmony export */   "bU": function() { return /* binding */ tradingEndpoints; }
/* harmony export */ });
/* unused harmony export maintenanceEndpoint */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83153);


var authEndpoint = {
    authRefresh: "/auth/refresh"
};
var _obj, _obj1;
var portfolioEndpoint = {
    portfolio: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .UserTargetAPI.LEGACY */ .FA.LEGACY, "/portfolio"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .UserTargetAPI.NEW_CORE */ .FA.NEW_CORE, "/securities/portfolio/v1/list"), _obj),
    portfolioDetail: (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .UserTargetAPI.LEGACY */ .FA.LEGACY, function(symbol) {
        return "/portfolio/detail?symbol=".concat(symbol);
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .UserTargetAPI.NEW_CORE */ .FA.NEW_CORE, function(symbol) {
        return "/portfolio/v2/detail?stock_code=".concat(symbol);
    }), _obj1)
};
var emittenEndpoint = {
    emittenInfo: function(symbol) {
        return "/emitten/".concat(symbol, "/info");
    }
};
var orderbookEndpoint = {
    orderbookCompanies: function(symbol) {
        return "/company-price-feed/v2/orderbook/companies/".concat(symbol);
    }
};
var maintenanceEndpoint = {
    getStatus: "/oms/auth/maintenance/status"
};
var orderEndpoint = {
    bulkCancelByOrderId: "/order/v2/bulk-cancel",
    orderDetail: "/order/v2/detail"
};
var termsAndConditionsEndpoint = {
    getTnCByFeature: function(featureId) {
        return "/tnc/".concat(featureId);
    },
    postTnCAcceptance: function() {
        return "/tnc/acceptance";
    }
};
// terms and condition v2
var termsAndConditionsAPI = {
    getTnCByFeature: function(featureIds) {
        var featuresQs = featureIds.map(function(f) {
            return "feature_ids=".concat(f);
        }).join("&");
        return "/tnc/v2/get?".concat(featuresQs);
    },
    postTnCAcceptance: function() {
        return "/tnc/v2/acceptance";
    }
};
var tradingEndpoints = {
    getTradingInfo: "/trading/info"
};
var bondsEndpoints = {
    postBuy: "/bond/v1/buy",
    getBuyPreview: "/bond/v1/buy/preview",
    getOrderList: "/bond/v1/orders",
    getOrderDetail: function(id) {
        return "/bond/v1/orders/".concat(id);
    },
    getPortfolioList: "/bond/v1/portfolio",
    getPortfolioDetail: function(code) {
        return "/bond/v1/portfolio/".concat(code);
    },
    postSell: "/bond/v1/sell",
    getSellPreview: "/bond/v1/sell/preview"
};


/***/ }),

/***/ 9657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hg": function() { return /* binding */ balanceLabel; },
/* harmony export */   "IY": function() { return /* binding */ expiryId; },
/* harmony export */   "Me": function() { return /* binding */ expiryOptions; },
/* harmony export */   "Ud": function() { return /* binding */ orderTypeOptions; },
/* harmony export */   "nz": function() { return /* binding */ smartOrderText; },
/* harmony export */   "wc": function() { return /* binding */ expiryTypeById; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _types_transaction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2078);


var balanceLabel = {
    cashOnHand: "Cash On Hand",
    tradingBalance: "Trading Balance",
    tradingLimit: "Trading Limit",
    dayTrade: "Buying Power"
};
var _obj;
var smartOrderText = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderCode.AutoBuy */ .H1.AutoBuy, "Auto Buy"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderCode.StopLoss */ .H1.StopLoss, "Stop Loss"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderCode.TakeProfit */ .H1.TakeProfit, "Take Profit"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderCode.LimitIfTouched */ .H1.LimitIfTouched, "Limit If Touched"), _obj);
var _obj1;
var orderTypeOptions = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .TransactionType.Buy */ .iU.Buy, {
    "Limit Order": "Limit Order",
    AutoBuy: "Limit If Touched",
    "Auto Buy": "Limit If Touched",
    Market: "Market Order"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .TransactionType.Sell */ .iU.Sell, {
    "Limit Order": "Limit Order",
    StopLoss: smartOrderText.SL,
    TakeProfit: smartOrderText.TP,
    Market: "Market Order",
    "Trailing Stop": "Trailing Stop"
}), _obj1);
var _obj2;
var expiryOptions = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .Expiry.GoodForDay */ .ZM.GoodForDay, "Good For Day"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .Expiry.GoodTillCancelled */ .ZM.GoodTillCancelled, "Good Till Cancelled"), _obj2);
var _obj3;
var expiryId = (_obj3 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .Expiry.GoodForDay */ .ZM.GoodForDay, 0), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .Expiry.GoodTillCancelled */ .ZM.GoodTillCancelled, 1), _obj3);
var expiryTypeById = {
    0: _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .Expiry.GoodForDay */ .ZM.GoodForDay,
    1: _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .Expiry.GoodTillCancelled */ .ZM.GoodTillCancelled
};


/***/ }),

/***/ 71158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stores_useSecuritiesCredentialStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/types.ts
var types = __webpack_require__(20620);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/lib/api/securities.ts
var securities = __webpack_require__(65906);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/config/requestRefreshTrading.tsx
var requestRefreshTrading = __webpack_require__(47050);
// EXTERNAL MODULE: ./src/features/securities/utils.tsx
var utils = __webpack_require__(4621);
// EXTERNAL MODULE: ./src/lib/api/instances/exodus.ts
var exodus = __webpack_require__(78372);
;// CONCATENATED MODULE: ./src/lib/api/authSecurities.ts




var defaultInstance = exodus/* default.defaultInstance */.Z.defaultInstance;
var authSecurities_requestRefreshTrading = (0,requestRefreshTrading/* default */.Z)();
var postSwitchVirtual = function() {
    return defaultInstance.post("virtualtrading/account/activate");
};
var postAuthRefresh = function(refreshToken) {
    return authSecurities_requestRefreshTrading.post("".concat((0,utils/* isRedirectToNewCore */.JI)() ? api/* API_TRADING_URL_V2 */.cu : api/* API_TRADING_URL */.Cb, "/auth/refresh"), {
        refresh_token: refreshToken
    });
};

// EXTERNAL MODULE: ./src/lib/api/trade.ts
var trade = __webpack_require__(65141);
// EXTERNAL MODULE: ./src/lib/api/multi-porto.ts
var multi_porto = __webpack_require__(13083);
// EXTERNAL MODULE: ./src/lib/stores/multiPorto.ts
var multiPorto = __webpack_require__(34385);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
// EXTERNAL MODULE: ./src/utils/securitiesLocalStorage.ts + 1 modules
var securitiesLocalStorage = __webpack_require__(11763);
;// CONCATENATED MODULE: ./src/global/Securities/stores/useSecuritiesCredentialStore.ts














var initialState = {
    accountType: securitiesLocalStorage/* default.getTradingAccountType */.Z.getTradingAccountType(),
    accessToken: securitiesLocalStorage/* default.getSecuritiesToken */.Z.getSecuritiesToken().securitiesAccessToken,
    refreshToken: securitiesLocalStorage/* default.getSecuritiesToken */.Z.getSecuritiesToken().securitiesRefreshToken,
    type: securitiesLocalStorage/* default.getSecuritiesAccountInfo */.Z.getSecuritiesAccountInfo().accountType,
    accountNumber: securitiesLocalStorage/* default.getSecuritiesAccountInfo */.Z.getSecuritiesAccountInfo().accountNumber,
    mainAccountNumber: securitiesLocalStorage/* default.getSecuritiesAccountInfo */.Z.getSecuritiesAccountInfo().mainAccountNumber
};
var useSecuritiesCredentialStore = (0,esm/* default */.ZP)(function(set, get) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        resetStore: function() {
            set({
                accountType: null,
                accessToken: null,
                refreshToken: null,
                type: null,
                accountNumber: null,
                mainAccountNumber: null
            });
            // Reset order queue modal when user logs out
            __webpack_require__.e(/* import() */ 55756).then(__webpack_require__.bind(__webpack_require__, 55756)).then(function(param) {
                var useOrderQueueStore = param.default;
                useOrderQueueStore.getState().reset();
            });
        },
        switchAccountType: function(accountType) {
            return set({
                accountType: accountType
            });
        },
        loadLoginReal: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(pin) {
                var ref, ref1, loginTokenRes, ref2, ref3, loginToken, target, validatePinRes, ref4, ref5, data, error_type, message, ref6, accessToken, refreshToken, account, main_account, ref7, type, number, ref8, ref9, ref10, ref11;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            _ctx.next = 4;
                            return securities/* default.getAuthToken */.Z.getAuthToken();
                        case 4:
                            loginTokenRes = _ctx.sent;
                            ;
                            ref3 = (ref2 = loginTokenRes === null || loginTokenRes === void 0 ? void 0 : (ref = loginTokenRes.data) === null || ref === void 0 ? void 0 : ref.data) !== null && ref2 !== void 0 ? ref2 : {}, loginToken = ref3.token, target = ref3.target;
                            if (loginToken) {
                                _ctx.next = 9;
                                break;
                            }
                            throw Error("Get Login Token failed", {
                                cause: {
                                    type: "GET_AUTH_TOKEN"
                                }
                            });
                        case 9:
                            (0,utils/* setTargetAPI */.yM)(target);
                            _ctx.next = 12;
                            return securities/* default.postAuthPIN */.Z.postAuthPIN(loginToken, pin);
                        case 12:
                            validatePinRes = _ctx.sent;
                            ;
                            ref5 = (ref4 = validatePinRes === null || validatePinRes === void 0 ? void 0 : validatePinRes.data) !== null && ref4 !== void 0 ? ref4 : {}, data = ref5.data, error_type = ref5.error_type, message = ref5.message;
                            ref6 = data !== null && data !== void 0 ? data : {}, accessToken = ref6.access_token, refreshToken = ref6.refresh_token, account = ref6.account, main_account = ref6.main_account;
                            ref7 = account !== null && account !== void 0 ? account : {}, type = ref7.type, number = ref7.number;
                            if (!(error_type || !accessToken || !refreshToken)) {
                                _ctx.next = 19;
                                break;
                            }
                            throw Error(message || "Attemp to post Auth PIN failed", {
                                cause: {
                                    type: "POST_AUTH_PIN",
                                    error_type: error_type,
                                    message: message
                                }
                            });
                        case 19:
                            (ref1 = multiPorto/* default */.Z === null || multiPorto/* default */.Z === void 0 ? void 0 : multiPorto/* default.getState */.Z.getState()) === null || ref1 === void 0 ? void 0 : ref1.setActiveAccount(number);
                            securitiesLocalStorage/* default.saveSecuritiesToken */.Z.saveSecuritiesToken({
                                securitiesAccessToken: accessToken,
                                securitiesRefreshToken: refreshToken
                            });
                            securitiesLocalStorage/* default.saveSecuritiesAccountInfo */.Z.saveSecuritiesAccountInfo({
                                accountType: account === null || account === void 0 ? void 0 : account.type,
                                accountNumber: account === null || account === void 0 ? void 0 : account.number,
                                mainAccountNumber: main_account === null || main_account === void 0 ? void 0 : main_account.number
                            });
                            set({
                                accessToken: accessToken,
                                refreshToken: refreshToken,
                                accountType: types/* ACCOUNT_TYPE.REAL */.Q5.REAL,
                                type: type,
                                accountNumber: number,
                                mainAccountNumber: main_account === null || main_account === void 0 ? void 0 : main_account.number
                            });
                            return _ctx.abrupt("return", {
                                loginToken: loginToken,
                                target: target,
                                accessToken: accessToken,
                                refreshToken: refreshToken,
                                type: type,
                                number: number
                            });
                        case 26:
                            _ctx.prev = 26;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                            (0,logger/* default */.ZP)(_ctx.t0, {
                                event: "useSecuritiesCredentialStore@loadLoginReal",
                                errCause: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.cause,
                                errType: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref8 = _ctx.t0.response) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : ref9.error_type,
                                errMessage: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref10 = _ctx.t0.response) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.data) === null || ref11 === void 0 ? void 0 : ref11.message
                            });
                            throw _ctx.t0;
                        case 31:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        26
                    ]
                ]);
            }));
            return function(pin) {
                return _ref.apply(this, arguments);
            };
        }(),
        loadLoginVirtual: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var res, ref, ref1, ref2, ref3;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return postSwitchVirtual();
                    case 3:
                        res = _ctx.sent;
                        if (res === null || res === void 0 ? void 0 : res.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to switch to virtual failed");
                    case 6:
                        securitiesLocalStorage/* default.switchToVirtualTrading */.Z.switchToVirtualTrading();
                        set({
                            accountType: types/* ACCOUNT_TYPE.VIRTUAL */.Q5.VIRTUAL
                        });
                        _ctx.next = 15;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        (0,logger/* default */.ZP)(_ctx.t0, {
                            event: "useSecuritiesCredentialStore@loginVirtual",
                            errType: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.error_type,
                            errMessage: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref2 = _ctx.t0.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message
                        });
                        throw _ctx.t0;
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        })),
        loadLogout: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, accountType, accessToken, resetStore, ref1, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ref = get(), accountType = ref.accountType, accessToken = ref.accessToken, resetStore = ref.resetStore;
                        _ctx.prev = 1;
                        if (!(accountType === types/* ACCOUNT_TYPE.REAL */.Q5.REAL && accessToken)) {
                            _ctx.next = 9;
                            break;
                        }
                        ;
                        _ctx.next = 6;
                        return trade/* default.logout */.Z.logout();
                    case 6:
                        res = _ctx.sent;
                        if (!(res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.error)) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error("Attempt to logout trading failed");
                    case 9:
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        (0,logger/* default */.ZP)(_ctx.t0, {
                            event: "useSecuritiesCredentialStore@logout",
                            errCause: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.cause
                        });
                    case 14:
                        resetStore();
                        securitiesLocalStorage/* default.logoutTrading */.Z.logoutTrading();
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        })),
        loadRefresh: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, currentRefreshToken, logout, res, _data, ref1, accessToken, refreshToken;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ref = get(), currentRefreshToken = ref.refreshToken, logout = ref.loadLogout;
                        _ctx.prev = 1;
                        if (currentRefreshToken) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("Securities refresh token does not exist");
                    case 4:
                        _ctx.next = 6;
                        return postAuthRefresh(currentRefreshToken);
                    case 6:
                        res = _ctx.sent;
                        if (!(!(res === null || res === void 0 ? void 0 : res.data) || res.data.error)) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error("Attemp to refresh token failed");
                    case 9:
                        ;
                        ref1 = (_data = res.data.data) !== null && _data !== void 0 ? _data : {}, accessToken = ref1.access_token, refreshToken = ref1.refresh_token;
                        securitiesLocalStorage/* default.saveSecuritiesToken */.Z.saveSecuritiesToken({
                            securitiesAccessToken: accessToken,
                            securitiesRefreshToken: refreshToken
                        });
                        set({
                            accessToken: accessToken,
                            refreshToken: refreshToken
                        });
                        _ctx.next = 20;
                        break;
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](1);
                        logout();
                        (0,logger/* default */.ZP)(_ctx.t0, {
                            event: "useSecuritiesCredentialStore@refresh",
                            errCause: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.cause
                        });
                        throw _ctx.t0;
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    15
                ]
            ]);
        })),
        loadSwitchLoginReal: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(accountNumber) {
                var validatePinRes, ref, ref1, data, error_type, message, ref2, accessToken, refreshToken, account, main_account, ref3, type, number, tokenUpdateEvent, channel, ref4, ref5, ref6, ref7;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return multi_porto/* default.postSwitchAccount */.Z.postSwitchAccount(accountNumber);
                        case 3:
                            validatePinRes = _ctx.sent;
                            ;
                            ref1 = (ref = validatePinRes === null || validatePinRes === void 0 ? void 0 : validatePinRes.data) !== null && ref !== void 0 ? ref : {}, data = ref1.data, error_type = ref1.error_type, message = ref1.message;
                            ref2 = data !== null && data !== void 0 ? data : {}, accessToken = ref2.access_token, refreshToken = ref2.refresh_token, account = ref2.account, main_account = ref2.main_account;
                            ref3 = account !== null && account !== void 0 ? account : {}, type = ref3.type, number = ref3.number;
                            if (!(error_type || !accessToken || !refreshToken)) {
                                _ctx.next = 10;
                                break;
                            }
                            throw Error(message || "Attemp to Switch Sub Account failed", {
                                cause: {
                                    type: "POST_SWITCH_SUB_ACCOUNT",
                                    error_type: error_type,
                                    message: message
                                }
                            });
                        case 10:
                            securitiesLocalStorage/* default.saveSecuritiesToken */.Z.saveSecuritiesToken({
                                securitiesAccessToken: accessToken,
                                securitiesRefreshToken: refreshToken
                            });
                            securitiesLocalStorage/* default.saveSecuritiesAccountInfo */.Z.saveSecuritiesAccountInfo({
                                accountType: account === null || account === void 0 ? void 0 : account.type,
                                accountNumber: account === null || account === void 0 ? void 0 : account.number,
                                mainAccountNumber: main_account === null || main_account === void 0 ? void 0 : main_account.number
                            });
                            tokenUpdateEvent = new CustomEvent("updateMultiPorto", {
                                detail: {
                                    number: number
                                }
                            });
                            window.dispatchEvent(tokenUpdateEvent);
                            channel = new BroadcastChannel("updateMultiPorto");
                            channel.postMessage({
                                number: number
                            });
                            set({
                                accessToken: accessToken,
                                refreshToken: refreshToken,
                                accountType: types/* ACCOUNT_TYPE.REAL */.Q5.REAL,
                                type: type,
                                accountNumber: number,
                                mainAccountNumber: main_account === null || main_account === void 0 ? void 0 : main_account.number
                            });
                            return _ctx.abrupt("return", {
                                accessToken: accessToken,
                                refreshToken: refreshToken,
                                type: type,
                                number: number
                            });
                        case 20:
                            _ctx.prev = 20;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                            (0,logger/* default */.ZP)(_ctx.t0, {
                                event: "useSecuritiesCredentialStore@loadLoginReal",
                                errCause: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.cause,
                                errType: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref4 = _ctx.t0.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.error_type,
                                errMessage: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref6 = _ctx.t0.response) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : ref7.message
                            });
                            throw _ctx.t0;
                        case 25:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        20
                    ]
                ]);
            }));
            return function(accountNumber) {
                return _ref.apply(this, arguments);
            };
        }()
    });
});
/* harmony default export */ var stores_useSecuritiesCredentialStore = (useSecuritiesCredentialStore);


/***/ }),

/***/ 73921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sn": function() { return /* binding */ BondProductTypeEnum; },
/* harmony export */   "qB": function() { return /* binding */ BondTransactionActionEnum; },
/* harmony export */   "ro": function() { return /* binding */ BondOrderStatus; }
/* harmony export */ });
/* unused harmony export BondTaxPreviewTypeEnum */
// Enums
var BondTransactionActionEnum;
(function(BondTransactionActionEnum) {
    BondTransactionActionEnum["UNSPECIFIED"] = "ACTION_UNSPECIFIED";
    BondTransactionActionEnum["BUY"] = "ACTION_BUY";
    BondTransactionActionEnum["SELL"] = "ACTION_SELL";
})(BondTransactionActionEnum || (BondTransactionActionEnum = {}));
var BondTaxPreviewTypeEnum;
(function(BondTaxPreviewTypeEnum) {
    BondTaxPreviewTypeEnum["UNSPECIFIED"] = "TAX_PREVIEW_UNSPECIFIED";
    BondTaxPreviewTypeEnum["SELL"] = "TAX_PREVIEW_SELL";
    BondTaxPreviewTypeEnum["ORDER"] = "TAX_PREVIEW_ORDER";
    BondTaxPreviewTypeEnum["HISTORY"] = "TAX_PREVIEW_HISTORY";
})(BondTaxPreviewTypeEnum || (BondTaxPreviewTypeEnum = {}));
var BondProductTypeEnum;
(function(BondProductTypeEnum) {
    BondProductTypeEnum["UNSPECIFIED"] = "PRODUCT_TYPE_UNSPECIFIED";
    BondProductTypeEnum["FR"] = "PRODUCT_TYPE_FR";
    BondProductTypeEnum["SBN"] = "PRODUCT_TYPE_SBN";
})(BondProductTypeEnum || (BondProductTypeEnum = {}));
var BondOrderStatus;
(function(BondOrderStatus) {
    BondOrderStatus["UNSPECIFIED"] = "BOND_ORDER_STATUS_UNSPECIFIED";
    BondOrderStatus["SUBMITTED"] = "BOND_ORDER_STATUS_SUBMITTED";
    BondOrderStatus["VERIFIED"] = "BOND_ORDER_STATUS_VERIFIED";
    BondOrderStatus["SUCCEEDED"] = "BOND_ORDER_STATUS_SUCCEEDED";
    BondOrderStatus["REJECTED"] = "BOND_ORDER_STATUS_REJECTED";
})(BondOrderStatus || (BondOrderStatus = {}));


/***/ }),

/***/ 2078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F4": function() { return /* binding */ PlatformOrderTypes; },
/* harmony export */   "H1": function() { return /* binding */ SmartOrderCode; },
/* harmony export */   "PH": function() { return /* binding */ SplitOrderMethodEnum; },
/* harmony export */   "XL": function() { return /* binding */ PaymentMethod; },
/* harmony export */   "ZM": function() { return /* binding */ Expiry; },
/* harmony export */   "dY": function() { return /* binding */ BuyOrderType; },
/* harmony export */   "iF": function() { return /* binding */ OrderStatus; },
/* harmony export */   "iU": function() { return /* binding */ TransactionType; },
/* harmony export */   "iX": function() { return /* binding */ OrderAction; },
/* harmony export */   "om": function() { return /* binding */ SmartOrderType; },
/* harmony export */   "qK": function() { return /* binding */ SellOrderType; }
/* harmony export */ });
var PaymentMethod;
(function(PaymentMethod) {
    PaymentMethod["TradingBalance"] = "TradingBalance";
    PaymentMethod["TradingLimit"] = "TradingLimit";
    PaymentMethod["DayTrade"] = "DayTrade";
})(PaymentMethod || (PaymentMethod = {}));
var BuyOrderType;
(function(BuyOrderType) {
    BuyOrderType["LimitOrder"] = "Limit Order";
    BuyOrderType["AutoBuy"] = "AutoBuy";
    BuyOrderType["Auto Buy"] = "Auto Buy";
    BuyOrderType["MarketOrder"] = "Market";
})(BuyOrderType || (BuyOrderType = {}));
var SellOrderType;
(function(SellOrderType) {
    SellOrderType["LimitOrder"] = "Limit Order";
    SellOrderType["StopLoss"] = "StopLoss";
    SellOrderType["TakeProfit"] = "TakeProfit";
    SellOrderType["MarketOrder"] = "Market";
    SellOrderType["TrailingStop"] = "Trailing Stop";
})(SellOrderType || (SellOrderType = {}));
var SmartOrderType;
(function(SmartOrderType) {
    SmartOrderType["AutoBuy"] = "AutoBuy";
    SmartOrderType["StopLoss"] = "StopLoss";
    SmartOrderType["TakeProfit"] = "TakeProfit";
})(SmartOrderType || (SmartOrderType = {}));
var SmartOrderCode;
(function(SmartOrderCode) {
    SmartOrderCode["AutoBuy"] = "AB";
    SmartOrderCode["StopLoss"] = "SL";
    SmartOrderCode["TakeProfit"] = "TP";
    SmartOrderCode["LimitIfTouched"] = "LIT_SELL";
})(SmartOrderCode || (SmartOrderCode = {}));
var TransactionType;
(function(TransactionType) {
    TransactionType["Buy"] = "Buy";
    TransactionType["Sell"] = "Sell";
})(TransactionType || (TransactionType = {}));
var Expiry;
(function(Expiry) {
    Expiry["GoodForDay"] = "Good For Day";
    Expiry["GoodTillCancelled"] = "Good Till Cancelled";
})(Expiry || (Expiry = {}));
var OrderAction;
(function(OrderAction) {
    OrderAction["Buy"] = "BUY";
    OrderAction["Sell"] = "SELL";
})(OrderAction || (OrderAction = {}));
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["Rejected"] = "REJECTED";
    OrderStatus["Open"] = "OPEN";
    OrderStatus["Amended"] = "AMENDED";
    OrderStatus["Withdrawn"] = "WITHDRAWN";
    OrderStatus["Match"] = "MATCH";
    OrderStatus["Ready"] = "READY";
    OrderStatus["Partial"] = "PARTIAL";
    OrderStatus["Pending"] = "PENDING";
    OrderStatus["Active"] = "ACTIVE";
    OrderStatus["RequestAmend"] = "REQUEST AMEND";
    OrderStatus["Succeed"] = "SUCCEEDED";
})(OrderStatus || (OrderStatus = {}));
var SplitOrderMethodEnum;
(function(SplitOrderMethodEnum) {
    SplitOrderMethodEnum["UNSPECIFIED"] = "SPLIT_ORDER_METHOD_UNSPECIFIED";
    SplitOrderMethodEnum["EQUAL"] = "SPLIT_ORDER_METHOD_EQUAL";
    SplitOrderMethodEnum["RANDOM"] = "SPLIT_ORDER_METHOD_RANDOM_RANGE";
})(SplitOrderMethodEnum || (SplitOrderMethodEnum = {}));
var PlatformOrderTypes;
(function(PlatformOrderTypes) {
    PlatformOrderTypes["UNSPECIFIED"] = "PLATFORM_ORDER_TYPE_UNSPECIFIED";
    PlatformOrderTypes["LIMIT"] = "PLATFORM_ORDER_TYPE_LIMIT_DAY";
    PlatformOrderTypes["FAK"] = "PLATFORM_ORDER_TYPE_MARKET_FAK";
    PlatformOrderTypes["FAST_ORDER"] = "PLATFORM_ORDER_TYPE_FAST_ORDER";
})(PlatformOrderTypes || (PlatformOrderTypes = {}));


/***/ }),

/***/ 38875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bv": function() { return /* binding */ initialSellPreview; },
/* harmony export */   "Ew": function() { return /* binding */ BondBlockerType; },
/* harmony export */   "H1": function() { return /* binding */ BOND_TRANSACTION_CONFIG; },
/* harmony export */   "Im": function() { return /* binding */ BondInfoType; },
/* harmony export */   "MD": function() { return /* binding */ BASE_UNIT_AMOUNT; },
/* harmony export */   "N2": function() { return /* binding */ MAX_UNIT_AMOUNT; },
/* harmony export */   "_y": function() { return /* binding */ BondsModalTypeEnum; },
/* harmony export */   "dX": function() { return /* binding */ initialBuyPreview; },
/* harmony export */   "eM": function() { return /* binding */ bondsErrorTypesMapping; },
/* harmony export */   "gG": function() { return /* binding */ STABLE_EARN_ICON_SRC; },
/* harmony export */   "sW": function() { return /* binding */ FALLBACK_AVATAR_SRC; }
/* harmony export */ });
/* unused harmony exports ModalType, DEBOUNCE_DURATION */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73921);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);



var FALLBACK_AVATAR_SRC = "icon/fr-placeholder.svg";
var STABLE_EARN_ICON_SRC = "icon/fr/icon-stable-earn.svg";
var ModalType;
(function(ModalType) {
    ModalType["UNSPECIFIED"] = "BOND_MODAL_UNSPECIFIED";
    ModalType["TRANSACTION"] = "BOND_MODAL_TRANSACTION";
    ModalType["INFORMATION"] = "BOND_MODAL_INFORMATION";
    ModalType["CONFIRMATION"] = "BOND_MODAL_CONFIRMATION";
    ModalType["BLOCKERS"] = "BOND_MODAL_BLOCKERS";
})(ModalType || (ModalType = {}));
var BondInfoType;
(function(BondInfoType) {
    BondInfoType["UNSPECIFIED"] = "BOND_INFO_UNSPECIFIED";
    BondInfoType["ACCRUED_INTEREST"] = "BOND_INFO_ACCRUED_INTEREST";
    BondInfoType["ACCRUED_INTEREST_SELLER"] = "BOND_INFO_ACCRUED_INTEREST_SELLER";
    BondInfoType["CAPITAL_GAIN_LOSS"] = "BOND_INFO_CAPITAL_GAIN_LOSS";
    BondInfoType["PNL_UNREALIZED"] = "BOND_INFO_PNL_UNREALIZED";
    BondInfoType["TOTAL_DAILY_COUPON"] = "BOND_INFO_TOTAL_DAILY_COUPON";
    BondInfoType["TOTAL_INVESTMENT_PROFIT"] = "BOND_INFO_TOTAL_INVESTMENT_PROFIT";
    BondInfoType["TOTAL_UNIT"] = "BOND_INFO_TOTAL_UNIT";
    BondInfoType["PROJECTED_RETURN"] = "BOND_INFO_PROJECTED_RETURN";
    BondInfoType["PNL_NETT"] = "BOND_INFO_PNL_NETT";
    BondInfoType["TOTAL_PROFIT_NETT"] = "BOND_INFO_TOTAL_PROFIT_NETT";
    BondInfoType["BUYING_PRICE"] = "BOND_INFO_BUYING_PRICE";
    BondInfoType["SELLING_PRICE"] = "BOND_INFO_SELLING_PRICE";
    BondInfoType["PROFIT"] = "BOND_INFO_PROFIT";
    BondInfoType["CASH_ON_HAND"] = "BOND_INFO_CASH_ON_HAND";
    BondInfoType["TAX"] = "BOND_INFO_TAX";
    BondInfoType["BOND_TAX"] = "BOND_INFO_BOND_TAX";
    BondInfoType["USER_COUPON"] = "BOND_INFO_USER_COUPON";
    BondInfoType["FEE"] = "FEE";
})(BondInfoType || (BondInfoType = {}));
var BondBlockerType;
(function(BondBlockerType) {
    BondBlockerType["UNSPECIFIED"] = "BOND_BLOCKER_UNSPECIFIED";
    BondBlockerType["MARKET_CLOSE"] = "BOND_BLOCKER_MARKET_CLOSE";
    BondBlockerType["UNAVAILABLE"] = "BOND_BLOCKER_UNAVAILABLE";
    BondBlockerType["TEMPORARY_UNAVAILABLE"] = "BOND_BLOCKER_TEMPORARY_UNAVAILABLE";
    BondBlockerType["PRICE_CHANGED"] = "BOND_BLOCKER_PRICE_CHANGED";
    BondBlockerType["MAINTENANCE"] = "BOND_BLOCKER_MAINTENANCE";
    BondBlockerType["SHARIA_VALIDATION"] = "BOND_BLOCKER_SHARIA_VALIDATION";
    BondBlockerType["STABLE_EARN"] = "BOND_BLOCKER_STABLE_EARN";
    BondBlockerType["GENERAL_ERROR"] = "BOND_BLOCKER_GENERAL_ERROR";
})(BondBlockerType || (BondBlockerType = {}));
var BondsModalTypeEnum;
(function(BondsModalTypeEnum) {
    BondsModalTypeEnum["UNSPECIFIED"] = "BOND_MODAL_UNSPECIFIED";
    BondsModalTypeEnum["ASSETS"] = "BOND_MODAL_ASSETS";
    BondsModalTypeEnum["BLOCKERS"] = "BOND_MODAL_BLOCKERS";
    BondsModalTypeEnum["CONFIRMATION"] = "BOND_MODAL_CONFIRMATION";
    BondsModalTypeEnum["HISTORY"] = "BOND_MODAL_HISTORY";
    BondsModalTypeEnum["ORDER"] = "BOND_MODAL_ORDER";
    BondsModalTypeEnum["PORTFOLIO"] = "BOND_MODAL_PORTFOLIO";
    BondsModalTypeEnum["TNC"] = "BOND_MODAL_TNC";
    BondsModalTypeEnum["TRANSACTION"] = "BOND_MODAL_TRANSACTION";
    BondsModalTypeEnum["ORDER_PLACED"] = "BOND_MODAL_ORDER_PLACED";
    BondsModalTypeEnum["COUPON_RECEIPT"] = "BOND_MODAL_COUPON_RECEIPT";
})(BondsModalTypeEnum || (BondsModalTypeEnum = {}));
var _obj;
// Modal Config
var BOND_TRANSACTION_CONFIG = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_0__/* .BondTransactionActionEnum.UNSPECIFIED */ .qB.UNSPECIFIED, {
    title: "",
    textColor: "#333333",
    content: []
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_0__/* .BondTransactionActionEnum.BUY */ .qB.BUY, {
    title: "Buy",
    textColor: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    content: []
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_0__/* .BondTransactionActionEnum.SELL */ .qB.SELL, {
    title: "Sell",
    textColor: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].sunsetOrange */ .Z.sunsetOrange,
    content: []
}), _obj);
var bondsErrorTypesMapping = {
    product_not_found: BondBlockerType.UNAVAILABLE,
    price_rate_not_found: BondBlockerType.UNAVAILABLE,
    fr_in_record_date_period: BondBlockerType.TEMPORARY_UNAVAILABLE,
    fr_bonds_market_close: BondBlockerType.MARKET_CLOSE,
    price_has_changed: BondBlockerType.PRICE_CHANGED,
    user_sharia_validation: BondBlockerType.SHARIA_VALIDATION,
    stable_earn_cannot_be_sold_outside_bibit: BondBlockerType.STABLE_EARN
};
// Transactions Config
var MAX_UNIT_AMOUNT = 9999999;
var DEBOUNCE_DURATION = 500; // 500ms or 0.5 seconds
var BASE_UNIT_AMOUNT = 1000000; // Base unit amount is 1 million rupiah
// Initial states
var initialBuyPreview = {
    product: {
        type: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_0__/* .BondProductTypeEnum.FR */ .Sn.FR,
        id: "",
        name: "",
        min_order: "",
        icon_url: ""
    },
    unit: "0",
    rdn: {
        account_name: "",
        bank: {
            id: "0",
            name: "",
            color_hex: ""
        },
        balance: 0
    },
    settlement_date: "",
    accrued_interest: 0,
    buy_price_amount: 0,
    invested_amount: 0,
    price_rate: 0,
    estimation_amount: 0,
    total_amount: 0,
    fee: {
        stamp_duty: 0,
        tax: 0
    }
};
var initialSellPreview = {
    action: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_0__/* .BondTransactionActionEnum.SELL */ .qB.SELL,
    available_units: 0,
    units: 0,
    sell_amount: 0,
    accrued_interest: 0,
    amount: 0,
    profit_loss: 0,
    price: {
        deal: 0,
        markup: 0,
        buy: 0,
        sell: 0
    },
    fee: {
        stamp_duty: 0,
        capital_gain_tax: 0,
        accrued_interest_tax: 0,
        commission_fee: 0,
        total_tax: 0,
        tax_percent: 0,
        accrued_interest_exclude_tax: 0,
        estimation_amount_exclude_tax: 0
    },
    product: {
        type: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_0__/* .BondProductTypeEnum.FR */ .Sn.FR,
        id: "",
        name: "",
        min_order: "0",
        icon_url: ""
    },
    acquisition: {
        price: 0,
        date: null,
        order_id: ""
    },
    profit_loss_nett: 0,
    daily_accrued_interest: 0,
    invested_amount: 0,
    accrued_interest_exclude_tax: 0,
    estimation_amount_exclude_tax: 0,
    settlement_date: null,
    next_coupon_date: null,
    last_coupon_date: null,
    estimation_sell_amount: 0,
    estimation_disburse_amount: 0,
    capital_gain_loss_nett: 0,
    profit_loss_nett_percentage: 0,
    seller_coupon: 0,
    total_realized_amount: 0,
    total_realized_amount_percentage: 0,
    transaction_pnl: 0
};


/***/ }),

/***/ 10893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59148);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38875);




var initialState = {
    errorCode: 0,
    errorMessage: "",
    errorType: "",
    blockerType: _constants__WEBPACK_IMPORTED_MODULE_0__/* .BondBlockerType.UNSPECIFIED */ .Ew.UNSPECIFIED
};
var useBondError = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, initialState), {
        setErrorCode: function(code) {
            var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
            var blockerType = _constants__WEBPACK_IMPORTED_MODULE_0__/* .bondsErrorTypesMapping */ .eM[type];
            set({
                errorCode: code,
                errorMessage: message,
                errorType: type,
                blockerType: blockerType
            });
        },
        resetErrorCode: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useBondError);


/***/ }),

/***/ 20620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q5": function() { return /* binding */ ACCOUNT_TYPE; },
/* harmony export */   "fG": function() { return /* binding */ MODAL_TYPE; },
/* harmony export */   "h$": function() { return /* binding */ LEVERAGE; }
/* harmony export */ });
var ACCOUNT_TYPE;
(function(ACCOUNT_TYPE) {
    ACCOUNT_TYPE["REAL"] = "real";
    ACCOUNT_TYPE["VIRTUAL"] = "virtual";
})(ACCOUNT_TYPE || (ACCOUNT_TYPE = {}));
var MODAL_TYPE;
(function(MODAL_TYPE) {
    MODAL_TYPE["ANNOUNCEMENT"] = "ANNOUNCEMENT";
    MODAL_TYPE["TRANSACTION"] = "TRANSACTION";
    MODAL_TYPE["AUTO_ORDER"] = "AUTO_ORDER";
    MODAL_TYPE["AUTOBUY_TNC"] = "AUTOBUY_TNC";
    MODAL_TYPE["TRADING_LIMIT_TNC"] = "TRADING_LIMIT_TNC";
    MODAL_TYPE["SPLIT_ORDER_INFO"] = "SPLIT_ORDER_INFO";
    MODAL_TYPE["SPLIT_ORDER_METHOD_INFO"] = "SPLIT_ORDER_METHOD_INFO";
    MODAL_TYPE["ORDER_TYPE"] = "ORDER_TYPE";
    MODAL_TYPE["PREVIEW"] = "PREVIEW";
    MODAL_TYPE["EXCHANGE_FEE"] = "EXCHANGE_FEE";
    MODAL_TYPE["ORDER_PLACED"] = "ORDER_PLACED";
    MODAL_TYPE["SPECIAL_MONITORING"] = "SPECIAL_MONITORING";
    MODAL_TYPE["DAY_TRADE_ONBOARDING"] = "DAY_TRADE_ONBOARDING";
    MODAL_TYPE["DAY_TRADE_TNC"] = "DAY_TRADE_TNC";
    MODAL_TYPE["DAY_TRADE_CONFIRMATION"] = "DAY_TRADE_CONFIRMATION";
    MODAL_TYPE["DAY_TRADE_UNAVAILABLE"] = "DAY_TRADE_UNAVAILABLE";
    MODAL_TYPE["SHARIA_UNAVAILABLE"] = "SHARIA_UNAVAILABLE";
    MODAL_TYPE["SMART_ORDER_PLACED"] = "SMART_ORDER_PLACED";
})(MODAL_TYPE || (MODAL_TYPE = {}));
var LEVERAGE;
(function(LEVERAGE) {
    LEVERAGE["DAY_TRADE"] = "day-trade";
    LEVERAGE["REGULAR"] = "regular";
})(LEVERAGE || (LEVERAGE = {}));


/***/ }),

/***/ 13083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var config_requestTrading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48884);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var requestTrading = (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, false, false);
var getSubAccounts = function() {
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/v2/sub-account/list"));
};
var getPurposes = function() {
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/sub-account/purposes"));
};
var getTransferableStocks = function(accountNumber) {
    var query = new URLSearchParams({
        target_account_number: accountNumber
    });
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/portfolio/v2/transferable-stocks?").concat(query));
};
var getTradingBalance = function() {
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/portfolio/v2/summary"));
};
var postCreatePorto = function(payload) {
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/sub-account/create"), payload);
};
var postSwitchAccount = function(accountNumber) {
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/auth/account/switch"), {
        account_number: accountNumber
    });
};
var postRenamePorto = function(payload) {
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/sub-account/rename"), payload);
};
var postMoveCash = function(payload) {
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/intraservice/multi-portfolio/v1/move-cash"), payload);
};
var postMoveStock = function(payload) {
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/intraservice/multi-portfolio/v1/move-stock"), payload);
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getSubAccounts: getSubAccounts,
    getPurposes: getPurposes,
    getTransferableStocks: getTransferableStocks,
    getTradingBalance: getTradingBalance,
    postCreatePorto: postCreatePorto,
    postSwitchAccount: postSwitchAccount,
    postRenamePorto: postRenamePorto,
    postMoveCash: postMoveCash,
    postMoveStock: postMoveStock
});


/***/ }),

/***/ 44590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var request = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
var SEARCH_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/search");
var SEARCH_RECENT = "".concat(SEARCH_URL, "/recent");
var SEARCH_TYPES = {
    USERS: "users",
    ALL: "all",
    COMPANY: "company",
    EMITEN: "emiten"
};
var getSearchPeople = function(keyword) {
    var page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return request.get(SEARCH_URL, {
        params: {
            keyword: keyword,
            page: page,
            type: SEARCH_TYPES.USERS
        }
    });
};
var getSearchCompany = function(keyword) {
    var page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, firstCharSearch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (keyword.length > 1 || firstCharSearch) {
        return request.get(SEARCH_URL, {
            params: {
                keyword: keyword,
                page: page,
                type: SEARCH_TYPES.COMPANY
            }
        });
    }
    return null;
};
var getSearchRecent = function() {
    return request.get(SEARCH_RECENT);
};
var postSearchRecent = function(keyword, target, type) {
    return request.post(SEARCH_RECENT, {
        keyword: keyword,
        target: target,
        type: type
    });
};
var getSearch = function(keyword) {
    if (keyword.length > 1) {
        return request.get(SEARCH_URL, {
            params: {
                keyword: keyword,
                page: 0,
                type: SEARCH_TYPES.ALL
            }
        });
    }
    return null;
};
var getSearchEmiten = function(keyword) {
    var page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return request.get(SEARCH_URL, {
        params: {
            keyword: keyword,
            page: page,
            type: SEARCH_TYPES.EMITEN,
            country: "ID"
        }
    });
};
// Exports ---------------------------------------------------------------------
/* harmony default export */ __webpack_exports__["Z"] = ({
    getSearchPeople: getSearchPeople,
    getSearchCompany: getSearchCompany,
    getSearchRecent: getSearchRecent,
    getSearch: getSearch,
    postSearchRecent: postSearchRecent,
    getSearchEmiten: getSearchEmiten
});


/***/ }),

/***/ 65906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var config_requestTrading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48884);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37213);
/* harmony import */ var features_securities_withdrawal_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78765);
/* harmony import */ var features_securities_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4621);





var requestNonTrading = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].noAlert */ .Z.noAlert;
var requestNonTradingWithAlert = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].defaultInstance */ .Z.defaultInstance;
var requestTrading = (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(undefined, false, false);
var requestTradingURLEncoded = (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(undefined, true, true);
var requestTradingV2 = (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, false, false);
var RESET_PIN_EXODUS = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/user/setting/pin");
/**
 * Get securities login token
 * @return {APIResponse}
 */ var getAuthToken = function() {
    return requestNonTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/sekuritas/auth/token"));
};
/**
 * Verify Trading PIN submitted by user
 * @param {string} loginToken - generated from postAuthToken
 * @param {string} pin - PIN submitted by user
 * @return {APIResponse}
 */ var postAuthPIN = function(loginToken, PIN) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/auth/v2/login"), {
            login_token: loginToken,
            pin: PIN
        });
    }
    return requestTradingURLEncoded.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL */ .Cb, "/auth/pin"), {
        loginToken: loginToken,
        pin: PIN
    });
};
/**
 * Get OA Status
 * @return {APIResponse}
 */ var getOAStatus = function() {
    return requestNonTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_SECURITIES_GENERAL_URL */ .kg, "/v2/registration/check"));
};
/**
 * Request Forgot Pin
 * @return {APIResponse}
 */ var requestForgotPin = function(identity, channel) {
    return requestNonTradingWithAlert.post("".concat(RESET_PIN_EXODUS, "/phone/send"), {
        identity: identity,
        channel: channel
    });
};
/**
 * Request Forgot Pin when user not login in securitas
 * @param {string} token - generated from requestForgotPin
 * @param {string} otp - user input
 * @return {APIResponse}
 */ var verifyPin = function(token, otp) {
    return requestNonTradingWithAlert.post("".concat(RESET_PIN_EXODUS, "/phone/validate"), {
        token: token,
        otp: otp
    });
};
/**
 * Request Forgot Pin
 * @param {string} token - generated from reset pin page paramater
 * @return {APIResponse}
 */ var verifyToken = function(token) {
    return requestNonTradingWithAlert.post("".concat(RESET_PIN_EXODUS, "/email/validate"), {
        token: token
    });
};
/**
 * Request Forgot Pin
 * @param {string} reset_pin_token - generated from verifyToken
 * @param {string} new_pin - user input
 * @return {APIResponse}
 */ var updatePin = function(reset_pin_token, new_pin) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/auth/pin/reset"), {
            reset_pin_token: reset_pin_token,
            new_pin: new_pin
        });
    }
    return requestTradingURLEncoded.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL */ .Cb, "/auth/resetpin"), {
        reset_pin_token: reset_pin_token,
        new_pin: new_pin
    });
};
/**
 * Request Forgot Pin
 * @param {string[]} symbols - companies
 * @return {APIResponse}
 */ var getAllCorpAction = function(symbols) {
    return requestNonTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/corpaction/status"), {
        params: {
            symbol: symbols.join(",")
        }
    });
};
/**
 * Get Deposit Guide Data
 * @returns {APIResponse}
 */ var getDepositGuide = function() {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/deposit/guide"));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_SECURITIES_GENERAL_URL */ .kg, "/deposit/guide"));
};
var getAccountBankInfo = function() {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/account/bank"));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL */ .Cb, "/account/bank"));
};
var getBankAmendInfo = function() {
    return requestNonTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_SECURITIES_GENERAL_URL */ .kg, "/v2/account/bank/amend"));
};
var getForeignBankRules = function() {
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/withdrawal/v1/foreign-rules"));
};
var getTradingBalanceDetail = function(params) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        var ref = params || {}, accountNumber = ref.accountNumber, scope = ref.scope;
        var queryParam = "";
        if (scope === features_securities_withdrawal_types__WEBPACK_IMPORTED_MODULE_3__/* .BalanceScopeEnum.SELECTED_ACCOUNT */ .k.SELECTED_ACCOUNT) {
            queryParam = "?balance_scope=".concat(scope, "&account_number=").concat(accountNumber);
        }
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/balance/withdrawable").concat(queryParam));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_SECURITIES_GENERAL_URL */ .kg, "/withdraw/balance"));
};
var cashWithdrawal = function(params) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/withdrawal/v1/withdraw"), {
            amount: params.amount,
            ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)(),
            token_validate_pin: params.validation_pin_token,
            currency_code: params.currency_code,
            signature: params.signature,
            bank_swift_code: params.bank_swift_code,
            transfer_type: params.transfer_type
        });
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL */ .Cb, "/cash/withdraw/request"), params);
};
var cashWithdrawalMultiAccount = function(params) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/withdrawal/v1/withdraw/multi-account"), {
        transactions: params.transactions,
        ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)(),
        token_validate_pin: params.validation_pin_token,
        currency_code: params.currency_code,
        signature: params.signature,
        bank_swift_code: params.bank_swift_code,
        transfer_type: params.transfer_type
    });
};
var getDepositHistory = function(payload) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        var queries = new URLSearchParams({
            page: payload.page,
            limit: payload.limit,
            period: payload.period
        });
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/history/deposit?").concat(queries));
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL */ .Cb, "/cash/deposit/history"), payload);
};
var getWithdrawalHistory = function(payload) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        var queries = new URLSearchParams({
            page: payload.page,
            limit: payload.limit,
            period: payload.period
        });
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/history/withdraw?").concat(queries));
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL */ .Cb, "/cash/withdraw/history/v2"), payload);
};
var getTransferMethod = function(bankCode, beneficiaryBankCode) {
    return requestTradingV2.get("withdrawal/v1/option/".concat(bankCode, "?beneficiary_bank_code=").concat(beneficiaryBankCode));
};
var checkTransferOperatinStatus = function(param) {
    var bankCode = param.bankCode, transferType = param.transferType;
    return requestTradingV2.get("withdrawal/v1/option/".concat(bankCode, "/confirmation/").concat(transferType));
};
var getSuspensionList = function() {
    return requestTradingV2.get("/v1/account/suspension/list");
};
var getWithdrawPreviewCashSweep = function(params) {
    return requestTradingV2.get("/intraservice/cash-sweep/v1/withdraw/preview", {
        params: params
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getAuthToken: getAuthToken,
    postAuthPIN: postAuthPIN,
    getOAStatus: getOAStatus,
    requestForgotPin: requestForgotPin,
    verifyPin: verifyPin,
    verifyToken: verifyToken,
    updatePin: updatePin,
    getAllCorpAction: getAllCorpAction,
    getDepositGuide: getDepositGuide,
    getAccountBankInfo: getAccountBankInfo,
    getBankAmendInfo: getBankAmendInfo,
    getForeignBankRules: getForeignBankRules,
    getTradingBalanceDetail: getTradingBalanceDetail,
    cashWithdrawal: cashWithdrawal,
    cashWithdrawalMultiAccount: cashWithdrawalMultiAccount,
    getDepositHistory: getDepositHistory,
    getWithdrawalHistory: getWithdrawalHistory,
    getTransferMethod: getTransferMethod,
    checkTransferOperatinStatus: checkTransferOperatinStatus,
    getSuspensionList: getSuspensionList,
    getWithdrawPreviewCashSweep: getWithdrawPreviewCashSweep
});


/***/ }),

/***/ 65141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78372);
/* harmony import */ var config_requestTrading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48884);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37213);
/* harmony import */ var features_securities_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4621);
/* harmony import */ var global_Securities_constants_transactionForm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9657);
/* harmony import */ var global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2078);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_7__);









var requestTrading = (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, false, false);
var requestTradingV2 = (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, false, false);
var requestSocial = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].noAlert */ .Z.noAlert;
var getPortfolio = function() {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/portfolio/v2/list"));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/portfolio"));
};
var getConfigFormula = function() {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/formula/v2"));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/config/formula"));
};
var getTradingConfig = function() {
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/get"));
};
var unlinkTradingAccount = function(brokerKey) {
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/unlink"), {
        broker: brokerKey
    });
};
var getOrderList = function(gtc) {
    var stock_code = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        if (stock_code) {
            return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/v2/list"), {
                params: {
                    "filter_criteria.stock_code": stock_code
                }
            });
        }
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/v2/list"));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/order/list?gtc=").concat(gtc));
};
var getExerciseList = function() {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/exercise"));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/exercise/list"));
};
var getExercise = function(stockCode) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/exercise/exercisable?stockCode=").concat(stockCode));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/exercise/exerciseable/v2?stockCode=").concat(stockCode));
};
var checkRightTradeable = function() {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/exercise/tradable"));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/exercise/tradeable"));
};
var checkStockTradable = function(symbol) {
    return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/stock/tradable?stock_codes=").concat(symbol));
};
var getPortfolioDetail = function(symbol) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/portfolio/v2/detail?stock_code=").concat(symbol));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/portfolio/detail?symbol=").concat(symbol));
};
var getCashOnHand = function() {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/balance/cash"));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/account/cashonhand"));
};
var getHistory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/history"), {
                        params: params
                    }));
                case 2:
                    return _ctx.abrupt("return", requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/order/history/v4"), params));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getHistory(params) {
        return _ref.apply(this, arguments);
    };
}();
var getHistoryRealized = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/history/realized"), {
                        params: params,
                        paramsSerializer: function(p) {
                            return qs__WEBPACK_IMPORTED_MODULE_7___default().stringify(p, {
                                arrayFormat: "repeat"
                            });
                        }
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getHistoryRealized(params) {
        return _ref.apply(this, arguments);
    };
}();
var getHistoryRealizedDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/history/realized/detail"), {
                        params: params
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getHistoryRealizedDetail(params) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * @deprecated we should migrate to the /history or `getHistory` API
 */ var getTransactionHistory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var stockCode, period, _page, page, _limit, limit, queries;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    stockCode = param.stockCode, period = param.period, _page = param.page, page = _page === void 0 ? "1" : _page, _limit = param.limit, limit = _limit === void 0 ? "500" : _limit;
                    if (!(0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
                        _ctx.next = 4;
                        break;
                    }
                    queries = new URLSearchParams({
                        stockCode: stockCode,
                        period: period,
                        page: page,
                        limit: limit
                    });
                    return _ctx.abrupt("return", requestTradingV2("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/history/v3?").concat(queries)));
                case 4:
                    return _ctx.abrupt("return", requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/order/history/v3"), {
                        stockCode: stockCode,
                        period: period,
                        page: page,
                        limit: limit
                    }));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTransactionHistory(_) {
        return _ref.apply(this, arguments);
    };
}();
var tradeBuy = function(param) {
    var orderkey = param.orderkey, symbol = param.symbol, price = param.price, shares = param.shares, _boardtype = param.boardtype, boardtype = _boardtype === void 0 ? "RG" : _boardtype, gtc = param.gtc, split_order = param.split_order, platform_order_type = param.platform_order_type;
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        var body = {
            ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)(),
            symbol: symbol,
            price: price,
            shares: shares,
            board_type: boardtype,
            is_gtc: gtc === global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_6__/* .Expiry.GoodTillCancelled */ .ZM.GoodTillCancelled,
            time_in_force: "0",
            split_order: split_order,
            platform_order_type: platform_order_type
        };
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/v2/buy"), body);
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/order/buy"), {
        orderkey: orderkey,
        symbol: symbol,
        price: price,
        shares: shares,
        boardtype: boardtype,
        gtc: global_Securities_constants_transactionForm__WEBPACK_IMPORTED_MODULE_5__/* .expiryId */ .IY[gtc]
    });
};
var dayTradeBuy = function(param) {
    var symbol = param.symbol, price = param.price, shares = param.shares, multiplier = param.multiplier, platform_order_type = param.platform_order_type;
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/day-trade/v1/buy"), {
        ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)(),
        symbol: symbol,
        price: price,
        shares: shares,
        multiplier: multiplier,
        platform_order_type: platform_order_type
    });
};
var tradeSell = function(param) {
    var orderkey = param.orderkey, symbol = param.symbol, price = param.price, shares = param.shares, _boardtype = param.boardtype, boardtype = _boardtype === void 0 ? "RG" : _boardtype, _gtc = param.gtc, gtc = _gtc === void 0 ? global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_6__/* .Expiry.GoodForDay */ .ZM.GoodForDay : _gtc, split_order = param.split_order, platform_order_type = param.platform_order_type;
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        var body = {
            ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)(),
            symbol: symbol,
            price: price,
            shares: shares,
            board_type: boardtype,
            is_gtc: gtc === global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_6__/* .Expiry.GoodTillCancelled */ .ZM.GoodTillCancelled,
            time_in_force: "0",
            split_order: split_order,
            platform_order_type: platform_order_type
        };
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/v2/sell"), body);
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/order/sell"), {
        orderkey: orderkey,
        symbol: symbol,
        price: price,
        shares: shares,
        boardtype: boardtype,
        gtc: global_Securities_constants_transactionForm__WEBPACK_IMPORTED_MODULE_5__/* .expiryId */ .IY[gtc]
    });
};
var dayTradeSell = function(param) {
    var symbol = param.symbol, price = param.price, shares = param.shares, platform_order_type = param.platform_order_type;
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/day-trade/v1/sell"), {
        ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)(),
        symbol: symbol,
        price: price,
        shares: shares,
        platform_order_type: platform_order_type
    });
};
/**
 * @deprecated use `bulkTradeAmend` instead
 */ var tradeAmend = function(param) {
    var orderkey = param.orderkey, symbol = param.symbol, price = param.price, shares = param.shares, orderid = param.orderid, _boardtype = param.boardtype, boardtype = _boardtype === void 0 ? "RG" : _boardtype;
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        var body = {
            order_id: orderid,
            ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)(),
            symbol: symbol,
            price: price,
            shares: shares,
            board_type: boardtype
        };
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/v2/amend"), body);
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/order/amend"), {
        orderkey: orderkey,
        symbol: symbol,
        price: price,
        shares: shares,
        orderid: orderid
    });
};
var bulkTradeAmend = function(orders) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/v2/amend/bulk"), {
        ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)(),
        amend_request: orders
    });
};
var dayTradeAmend = function(param) {
    var orderid = param.orderid, price = param.price, shares = param.shares, multiplier = param.multiplier;
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/day-trade/v1/amend"), {
        ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)(),
        multiplier: multiplier,
        price: price,
        shares: shares,
        order_id: orderid
    });
};
var tradeCancel = function(data) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        var body = {
            order_id: data.orderid,
            ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)()
        };
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/v2/cancel"), body);
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/order/cancel"), data);
};
var dayTradeCancel = function(orderKey) {
    var data = {
        ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)(),
        order_id: orderKey
    };
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/day-trade/v1/cancel"), data);
};
var postRequestExercise = function(param) {
    var orderKey = param.orderKey, stockCode = param.stockCode, shares = param.shares;
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/exercise"), {
            stock_code: stockCode,
            shares: shares
        });
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/exercise/request"), {
        stock_code: stockCode,
        shares: shares,
        order_key: orderKey
    });
};
var logout = function() {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/logout"));
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/auth/logout"));
};
var getTradingProfile = function() {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/account"));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/account"));
};
var getTradingProfilePersonal = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", requestSocial.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_SECURITIES_GENERAL_URL */ .kg, "/account/personal")));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTradingProfilePersonal() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Validate PIN
 * @param {string} pin - user input
 * @param {string} type - string
 * @return {APIResponse}
 */ var checkPin = function(pin, type) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/pin/validate"), {
            pin: pin,
            purpose: type
        });
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/auth/pin/validate"), {
        pin: pin,
        type: type
    });
};
/**
 * Change PIN
 * @param {string} pin - user input
 * @param {string} type - string
 * @return {APIResponse}
 */ var changePin = function(old_pin, new_pin, token) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/pin/change"), {
            old_pin: old_pin,
            new_pin: new_pin,
            token: token
        });
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/auth/changepin"), {
        old_pin: old_pin,
        new_pin: new_pin,
        token: token
    });
};
var checkSubAccountDayTrade = function(type) {
    return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/account/sub-account/detail?type=").concat(type));
};
var deleteTrailingStop = function(orderId) {
    return requestTradingV2.delete("/smart-order/trailing-stop/v1/order/".concat(orderId));
};
var deleteStopOrder = function(orderId) {
    return requestTradingV2.delete("/smart-order/stop-order/v1/order/".concat(orderId));
};
var deleteBracketOrder = function(orderId) {
    return requestTradingV2.delete("/smart-order/bracket-order/v1/order/".concat(orderId));
};
var newChangePin = function(pin, token) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/v2/pin/change/new"), {
        pin: pin,
        token: token
    });
};
var confirmChangePin = function(pin, token) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/v2/pin/change/confirm"), {
        pin: pin,
        token: token
    });
};
var validateIdentity = function(identity) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/v2/pin/reset/validate"), {
        identity: identity
    });
};
var newResetPin = function(pin, token) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/v2/pin/reset/new"), {
        pin: pin,
        token: token
    });
};
var confirmResetPin = function(pin, token) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/v2/pin/reset/confirm"), {
        pin: pin,
        token: token
    });
};
var sendChangeOTP = function(token, channel) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/v2/pin/change/otp/send"), {
        token: token,
        channel: channel
    });
};
var verifyChangeOTP = function(token, otp) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/v2/pin/change/otp/verify"), {
        token: token,
        otp: otp
    });
};
var sendResetPinOTP = function(token, channel) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/v2/pin/reset/otp/send"), {
        token: token,
        channel: channel
    });
};
var verifyResetPinOTP = function(token, otp) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/v2/pin/reset/otp/verify"), {
        token: token,
        otp: otp
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getConfigFormula: getConfigFormula,
    getPortfolio: getPortfolio,
    getOrderList: getOrderList,
    getExerciseList: getExerciseList,
    // trade
    getExercise: getExercise,
    getPortfolioDetail: getPortfolioDetail,
    getCashOnHand: getCashOnHand,
    tradeBuy: tradeBuy,
    tradeSell: tradeSell,
    tradeAmend: tradeAmend,
    bulkTradeAmend: bulkTradeAmend,
    tradeCancel: tradeCancel,
    postRequestExercise: postRequestExercise,
    // day trade
    dayTradeBuy: dayTradeBuy,
    dayTradeSell: dayTradeSell,
    dayTradeAmend: dayTradeAmend,
    dayTradeCancel: dayTradeCancel,
    getTradingConfig: getTradingConfig,
    unlinkTradingAccount: unlinkTradingAccount,
    logout: logout,
    getHistory: getHistory,
    getHistoryRealized: getHistoryRealized,
    getHistoryRealizedDetail: getHistoryRealizedDetail,
    getTransactionHistory: getTransactionHistory,
    getTradingProfile: getTradingProfile,
    getTradingProfilePersonal: getTradingProfilePersonal,
    checkPin: checkPin,
    changePin: changePin,
    newChangePin: newChangePin,
    confirmChangePin: confirmChangePin,
    sendChangeOTP: sendChangeOTP,
    verifyChangeOTP: verifyChangeOTP,
    validateIdentity: validateIdentity,
    newResetPin: newResetPin,
    confirmResetPin: confirmResetPin,
    sendResetPinOTP: sendResetPinOTP,
    verifyResetPinOTP: verifyResetPinOTP,
    checkRightTradeable: checkRightTradeable,
    checkStockTradable: checkStockTradable,
    checkSubAccountDayTrade: checkSubAccountDayTrade,
    deleteTrailingStop: deleteTrailingStop,
    deleteStopOrder: deleteStopOrder,
    deleteBracketOrder: deleteBracketOrder
});


/***/ }),

/***/ 66679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37213);
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68425);


var requestExodus = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
var getWSTradingKey = function() {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/auth/websocket/key"));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getWSKey: getWSTradingKey,
    getWSTradingKey: getWSTradingKey
});


/***/ }),

/***/ 34385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14671);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38597);
/* harmony import */ var lib_api_multi_porto__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13083);
/* harmony import */ var lib_api_securities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65906);
/* harmony import */ var features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3683);
/* harmony import */ var config_requestTrading_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68481);










var UNAUTHORIZED = 401;
var defaultInitialState = {
    isLoading: false,
    error: ""
};
var subAccountsInitialState = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, defaultInitialState), {
    data: {
        regular: {
            accounts: [],
            can_create_new_account: false,
            can_not_create_new_account_reason: undefined
        },
        margin: {
            accounts: [],
            can_create_new_account: false,
            can_not_create_new_account_reason: undefined
        }
    }
});
var subAccountsPurposeInitialState = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, defaultInitialState), {
    data: {
        purposes: []
    }
});
var withDrawableInitialState = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, defaultInitialState), {
    data: {
        balance: {
            withdrawable: 0,
            transaction: 0,
            pending: 0,
            leverage_liability: 0,
            net_withdrawable: 0
        },
        settlement_schedules: [],
        legends: []
    }
});
var tradingBalanceInitialState = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, defaultInitialState), {
    data: {
        balance: 0,
        equity: 0
    }
});
var portfoliosStockInitialState = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, defaultInitialState), {
    data: {
        stocks: []
    }
});
var createPortfolioFormInitialState = {
    portfolio_name: "",
    tnc: {
        feature_id: "",
        version: 0
    },
    purpose: ""
};
var renamePortfolioFormInitialState = {
    target_account_number: "",
    new_portfolio_name: ""
};
var moveCashFormInitialState = {
    from_acc_no: "",
    to_acc_no: "",
    amount: 0
};
var moveStockFormInitialState = {
    from_acc_no: "",
    to_acc_no: "",
    stocks_data: []
};
var initialState = {
    activeAccount: "",
    subAccountsData: subAccountsInitialState,
    subAccountsPurposeData: subAccountsPurposeInitialState,
    withDrawableData: withDrawableInitialState,
    transferableStocks: portfoliosStockInitialState,
    tradingBalanceData: tradingBalanceInitialState,
    hideOddLot: false,
    createPortfolioForm: createPortfolioFormInitialState,
    renamePortfolioForm: renamePortfolioFormInitialState,
    moveCashForm: moveCashFormInitialState,
    moveStockForm: moveStockFormInitialState
};
var useMultiPortfolioStore = (0,zustand__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)()((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_7__/* .devtools */ .mW)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_7__/* .persist */ .tJ)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        getSubAccounts: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, currentData, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        currentData = (ref = get()) === null || ref === void 0 ? void 0 : ref.subAccountsData;
                        set({
                            subAccountsData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                isLoading: true
                            })
                        });
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return lib_api_multi_porto__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSubAccounts */ .Z.getSubAccounts();
                    case 6:
                        data = _ctx.sent.data;
                        set({
                            subAccountsData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                data: data.data,
                                error: "",
                                isLoading: false
                            })
                        });
                        return _ctx.abrupt("return", data.data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](3);
                        set({
                            subAccountsData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                error: _ctx.t0,
                                isLoading: false
                            })
                        });
                        if (_ctx.t0.status === UNAUTHORIZED) {
                            features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getState */ .Z.getState().closeModal();
                        }
                        return _ctx.abrupt("return", _ctx.t0);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    11
                ]
            ]);
        })),
        getPurposes: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, currentData, data, status;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        currentData = (ref = get()) === null || ref === void 0 ? void 0 : ref.subAccountsPurposeData;
                        set({
                            subAccountsPurposeData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                isLoading: true
                            })
                        });
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return lib_api_multi_porto__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getPurposes */ .Z.getPurposes();
                    case 6:
                        data = _ctx.sent.data;
                        set({
                            subAccountsPurposeData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                data: data.data,
                                error: "",
                                isLoading: false
                            })
                        });
                        return _ctx.abrupt("return", data.data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](3);
                        set({
                            subAccountsPurposeData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, subAccountsPurposeInitialState), {
                                error: _ctx.t0,
                                isLoading: false
                            })
                        });
                        status = (0,config_requestTrading_utils__WEBPACK_IMPORTED_MODULE_9__/* .getErrorConfig */ .v)(_ctx.t0).status;
                        if (status === UNAUTHORIZED) {
                            features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getState */ .Z.getState().closeModal();
                        }
                        return _ctx.abrupt("return", _ctx.t0);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    11
                ]
            ]);
        })),
        getWithdrawable: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(scope, accountNumber) {
                var ref, currentData, params, data, status;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            currentData = (ref = get()) === null || ref === void 0 ? void 0 : ref.withDrawableData;
                            set({
                                withDrawableData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                    isLoading: true
                                })
                            });
                            _ctx.prev = 3;
                            params = {
                                scope: scope,
                                accountNumber: accountNumber
                            };
                            _ctx.next = 7;
                            return lib_api_securities__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getTradingBalanceDetail */ .Z.getTradingBalanceDetail(params);
                        case 7:
                            data = _ctx.sent.data;
                            set({
                                withDrawableData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                    data: data.data,
                                    error: "",
                                    isLoading: false
                                })
                            });
                            return _ctx.abrupt("return", data.data);
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](3);
                            set({
                                withDrawableData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, withDrawableInitialState), {
                                    error: _ctx.t0,
                                    isLoading: false
                                })
                            });
                            status = (0,config_requestTrading_utils__WEBPACK_IMPORTED_MODULE_9__/* .getErrorConfig */ .v)(_ctx.t0).status;
                            if (status === UNAUTHORIZED) {
                                features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getState */ .Z.getState().closeModal();
                            }
                            return _ctx.abrupt("return", _ctx.t0);
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        12
                    ]
                ]);
            }));
            return function(scope, accountNumber) {
                return _ref.apply(this, arguments);
            };
        }(),
        getTransferableStocks: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(account) {
                var ref, currentData, data, status;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            currentData = (ref = get()) === null || ref === void 0 ? void 0 : ref.transferableStocks;
                            set({
                                transferableStocks: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                    isLoading: true
                                })
                            });
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return lib_api_multi_porto__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getTransferableStocks */ .Z.getTransferableStocks(account);
                        case 6:
                            data = _ctx.sent.data;
                            set({
                                transferableStocks: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                    data: data.data,
                                    error: "",
                                    isLoading: false
                                })
                            });
                            return _ctx.abrupt("return", data.data);
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](3);
                            set({
                                transferableStocks: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, portfoliosStockInitialState), {
                                    error: _ctx.t0,
                                    isLoading: false
                                })
                            });
                            status = (0,config_requestTrading_utils__WEBPACK_IMPORTED_MODULE_9__/* .getErrorConfig */ .v)(_ctx.t0).status;
                            if (status === UNAUTHORIZED) {
                                features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getState */ .Z.getState().closeModal();
                            }
                            return _ctx.abrupt("return", _ctx.t0);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        11
                    ]
                ]);
            }));
            return function(account) {
                return _ref.apply(this, arguments);
            };
        }(),
        getTradingBalance: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, currentData, data, ref1, summary, status;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        currentData = (ref = get()) === null || ref === void 0 ? void 0 : ref.tradingBalanceData;
                        set({
                            tradingBalanceData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                isLoading: true
                            })
                        });
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return lib_api_multi_porto__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getTradingBalance */ .Z.getTradingBalance();
                    case 6:
                        data = _ctx.sent.data;
                        ref1 = data.data || {}, summary = ref1.aggregated_portfolio_summary;
                        set({
                            tradingBalanceData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                data: {
                                    balance: summary.trading.balance,
                                    equity: summary.equity
                                },
                                error: "",
                                isLoading: false
                            })
                        });
                        return _ctx.abrupt("return", data.data);
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](3);
                        set({
                            tradingBalanceData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, tradingBalanceInitialState), {
                                error: _ctx.t0,
                                isLoading: false
                            })
                        });
                        status = (0,config_requestTrading_utils__WEBPACK_IMPORTED_MODULE_9__/* .getErrorConfig */ .v)(_ctx.t0).status;
                        if (status === UNAUTHORIZED) {
                            features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getState */ .Z.getState().closeModal();
                        }
                        return _ctx.abrupt("return", _ctx.t0);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    12
                ]
            ]);
        })),
        resetTransferableStocks: function() {
            return set({
                transferableStocks: portfoliosStockInitialState
            });
        },
        resetWithdrawable: function() {
            return set({
                withDrawableData: withDrawableInitialState
            });
        },
        postCreatePorto: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
                var ref, data, status;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            _ctx.next = 4;
                            return lib_api_multi_porto__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postCreatePorto */ .Z.postCreatePorto(payload);
                        case 4:
                            data = _ctx.sent.data;
                            if (!(data === null || data === void 0 ? void 0 : data.data)) {
                                _ctx.next = 8;
                                break;
                            }
                            _ctx.next = 8;
                            return (ref = get()) === null || ref === void 0 ? void 0 : ref.getSubAccounts();
                        case 8:
                            return _ctx.abrupt("return", true);
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](0);
                            status = (0,config_requestTrading_utils__WEBPACK_IMPORTED_MODULE_9__/* .getErrorConfig */ .v)(_ctx.t0).status;
                            if (status === UNAUTHORIZED) {
                                features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getState */ .Z.getState().closeModal();
                            }
                            return _ctx.abrupt("return", _ctx.t0);
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        11
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        postRenamePorto: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
                var ref, data, status;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            _ctx.next = 4;
                            return lib_api_multi_porto__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postRenamePorto */ .Z.postRenamePorto(payload);
                        case 4:
                            data = _ctx.sent.data;
                            if (!(data === null || data === void 0 ? void 0 : data.data)) {
                                _ctx.next = 8;
                                break;
                            }
                            _ctx.next = 8;
                            return (ref = get()) === null || ref === void 0 ? void 0 : ref.getSubAccounts();
                        case 8:
                            return _ctx.abrupt("return", true);
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](0);
                            status = (0,config_requestTrading_utils__WEBPACK_IMPORTED_MODULE_9__/* .getErrorConfig */ .v)(_ctx.t0).status;
                            if (status === UNAUTHORIZED) {
                                features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getState */ .Z.getState().closeModal();
                            }
                            return _ctx.abrupt("return", _ctx.t0);
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        11
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        postMoveCash: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
                var status;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return lib_api_multi_porto__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postMoveCash */ .Z.postMoveCash(payload);
                        case 3:
                            return _ctx.abrupt("return", true);
                        case 6:
                            _ctx.prev = 6;
                            _ctx.t0 = _ctx["catch"](0);
                            status = (0,config_requestTrading_utils__WEBPACK_IMPORTED_MODULE_9__/* .getErrorConfig */ .v)(_ctx.t0).status;
                            if (status === UNAUTHORIZED) {
                                features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getState */ .Z.getState().closeModal();
                            }
                            return _ctx.abrupt("return", _ctx.t0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        6
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        postMoveStock: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
                var status;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return lib_api_multi_porto__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postMoveStock */ .Z.postMoveStock(payload);
                        case 3:
                            return _ctx.abrupt("return", true);
                        case 6:
                            _ctx.prev = 6;
                            _ctx.t0 = _ctx["catch"](0);
                            status = (0,config_requestTrading_utils__WEBPACK_IMPORTED_MODULE_9__/* .getErrorConfig */ .v)(_ctx.t0).status;
                            if (status === UNAUTHORIZED) {
                                features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getState */ .Z.getState().closeModal();
                            }
                            return _ctx.abrupt("return", _ctx.t0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        6
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        setActiveAccount: function(account) {
            return set({
                activeAccount: account
            });
        },
        setPortfolioForm: function(form) {
            return set({
                createPortfolioForm: form
            });
        },
        setRenamePortfolioForm: function(form) {
            return set({
                renamePortfolioForm: form
            });
        },
        setMoveCashForm: function(form) {
            return set({
                moveCashForm: form
            });
        },
        setMoveStockForm: function(form) {
            return set({
                moveStockForm: form
            });
        },
        resetMoveCashForm: function() {
            return set({
                moveCashForm: moveCashFormInitialState
            });
        },
        resetMoveStockForm: function() {
            return set({
                moveStockForm: moveStockFormInitialState
            });
        },
        resetState: function() {
            set(initialState);
        },
        setHideOddLot: function(value) {
            return set({
                hideOddLot: value
            });
        }
    });
}, {
    name: "multi-portfolio-storage",
    getStorage: function() {
        return localStorage;
    },
    partialize: function(state) {
        return {
            subAccountsData: state.subAccountsData,
            activeAccount: state.activeAccount,
            subAccountsPurposeData: state.subAccountsPurposeData,
            tradingBalanceData: state.tradingBalanceData,
            hideOddLot: state.hideOddLot
        };
    }
})));
/* harmony default export */ __webpack_exports__["Z"] = (useMultiPortfolioStore);


/***/ }),

/***/ 65458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dj": function() { return /* binding */ onReceiveMessage; },
/* harmony export */   "ZN": function() { return /* binding */ toggle; },
/* harmony export */   "kG": function() { return /* binding */ setNewSession; },
/* harmony export */   "l4": function() { return /* binding */ onLoaded; },
/* harmony export */   "lA": function() { return /* binding */ handleClickSupport; },
/* harmony export */   "te": function() { return /* binding */ destroyCurrentSession; },
/* harmony export */   "zp": function() { return /* binding */ onOpen; }
/* harmony export */ });
/* unused harmony exports crispReady, isCrispReady, createNewSession, resetSession, hide, safe, getSessionId, isChatOpened, isChatClosed */
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);
/* harmony import */ var constants_clevertap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92124);
/* harmony import */ var crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36661);
/* harmony import */ var _clevertap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48028);




function crispReady(cb) {
    var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1000;
    var $crisp = window.$crisp;
    if ($crisp && timeout < 1) {
        return cb($crisp);
    }
    setTimeout(function() {
        if ($crisp) {
            cb($crisp);
        } else {
            crispReady(cb, timeout);
        }
    }, timeout);
    return null;
}
var isCrispReady = function() {
    return (0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)() && !!window.$crisp;
};
function setNewSession(userData) {
    if (!isCrispReady()) return;
    // resetting session is necessary due to crisp autoloaded
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.session.reset */ .fv.session.reset();
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.close */ .fv.chat.close();
    if (!userData) return;
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.user.setNickname */ .fv.user.setNickname(userData.username);
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.user.setEmail */ .fv.user.setEmail(userData.email);
    if (userData === null || userData === void 0 ? void 0 : userData.phone) {
        crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.user.setPhone */ .fv.user.setPhone(userData.phone);
    }
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.user.setAvatar */ .fv.user.setAvatar("".concat(constants_app__WEBPACK_IMPORTED_MODULE_0__/* .AWS_AVATAR_BUCKET */ .cU, "/").concat(userData.avatar));
}
function createNewSession(param) {
    var email = param.email, fullname = param.fullname, id = param.id;
    window.CRISP_TOKEN_ID = id;
    setNewSession({
        email: email,
        fullname: fullname
    });
}
function destroyCurrentSession() {
    if (false) {}
    delete window.CRISP_TOKEN_ID;
    crispReady(function($crisp) {
        if ($crisp && $crisp.push) $crisp.push([
            "do",
            "session:reset"
        ]);
    }, 0);
}
function resetSession() {
    if (!isCrispReady()) return;
    Crisp.session.reset();
}
function hide() {
    if (!isCrispReady()) return;
    Crisp.chat.hide();
}
function toggle() {
    if (!isCrispReady()) return;
    var isOpened = crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.isChatOpened */ .fv.chat.isChatOpened();
    if (isOpened) {
        crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.close */ .fv.chat.close();
    } else {
        crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.show */ .fv.chat.show();
        crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.open */ .fv.chat.open();
    }
}
function onLoaded() {
    if (!isCrispReady()) return;
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.session.onLoaded */ .fv.session.onLoaded(function() {
        var isOpened = crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.isChatOpened */ .fv.chat.isChatOpened();
        if (!isOpened) {
            crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.close */ .fv.chat.close();
        }
    });
}
function onOpen() {
    if (!isCrispReady()) return;
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.onChatOpened */ .fv.chat.onChatOpened(function() {
        var unreadCount = document.querySelector(".intercom-unread-count");
        unreadCount.classList.remove("active");
    });
}
function safe() {
    if (!isCrispReady()) return;
    Crisp.setSafeMode(true);
}
function onReceiveMessage() {
    if (!isCrispReady()) return;
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.message.onMessageReceived */ .fv.message.onMessageReceived(function() {
        var unreadCount = crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.unreadCount */ .fv.chat.unreadCount();
        var unreadCountEl = document.querySelector(".intercom-unread-count");
        if (unreadCount > 0) {
            unreadCountEl.classList.add("active");
        }
    });
}
function getSessionId() {
    if (!isCrispReady()) return null;
    var sessionId = Crisp.session.getIdentifier();
    return sessionId;
}
function isChatOpened() {
    if (!isCrispReady()) return false;
    return Crisp.chat.isChatOpened();
}
function isChatClosed() {
    if (!isCrispReady()) return false;
    var isOpened = Crisp.chat.isChatOpened();
    return !isOpened;
}
var handleClickSupport = function() {
    if (!isCrispReady()) return;
    var isOpened = crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.isChatOpened */ .fv.chat.isChatOpened();
    if (isOpened) {
        crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.close */ .fv.chat.close();
    } else {
        crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.show */ .fv.chat.show();
        crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.open */ .fv.chat.open();
        (0,_clevertap__WEBPACK_IMPORTED_MODULE_3__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .CLEVERTAP_EVENT_NAME.SIDE_MENU */ .dR.SIDE_MENU, {
            Action: "support"
        });
    }
};


/***/ }),

/***/ 11763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ securitiesLocalStorage; }
});

// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
;// CONCATENATED MODULE: ./src/constants/securitiesLocalStorage.ts
var SECURITIES_ACCESS_TOKEN = "securitiesAccessToken";
var SECURITIES_REFRESH_TOKEN = "securitiesRefreshToken";
var SECURITIES_ACCOUNT_TYPE = "securitiesAccountType";
var SECURITIES_ACCOUNT_NUMBER = "securitiesAccountNumber";
var SECURITIES_MAIN_ACCOUNT_NUMBER = "securitiesMainAccountNumber";
var TRADE_IS_LOGGED_IN = "tradeIsLogin";
var TRADING_ACCOUNT_TYPE = "tradingAccountType";
var LAST_TRADING_ACCOUNT_TYPE = "lastTradingAccountType";
var TRADING_BROKER = "tradingBroker";


;// CONCATENATED MODULE: ./src/utils/securitiesLocalStorage.ts


function getSecuritiesToken() {
    var tokens = {
        securitiesAccessToken: null,
        securitiesRefreshToken: null
    };
    if ((0,app/* isClient */.C5)()) {
        tokens.securitiesAccessToken = localStorage.getItem(SECURITIES_ACCESS_TOKEN);
        tokens.securitiesRefreshToken = localStorage.getItem(SECURITIES_REFRESH_TOKEN);
    }
    return tokens;
}
function getTradingAccountType() {
    if (!(0,app/* isClient */.C5)()) {
        return null;
    }
    var tradingAccountType = localStorage.getItem(TRADING_ACCOUNT_TYPE);
    return tradingAccountType;
}
function saveSecuritiesToken(param) {
    var securitiesAccessToken = param.securitiesAccessToken, securitiesRefreshToken = param.securitiesRefreshToken;
    if ((0,app/* isClient */.C5)()) {
        localStorage.setItem(SECURITIES_ACCESS_TOKEN, securitiesAccessToken);
        localStorage.setItem(SECURITIES_REFRESH_TOKEN, securitiesRefreshToken);
        localStorage.setItem(TRADE_IS_LOGGED_IN, "true");
        localStorage.setItem(TRADING_ACCOUNT_TYPE, "real");
        localStorage.setItem(LAST_TRADING_ACCOUNT_TYPE, "real");
        localStorage.setItem(TRADING_BROKER, "stockbit");
    }
// Token for flagging that user is logged in
}
function saveSecuritiesAccountInfo(param) {
    var accountType = param.accountType, mainAccountNumber = param.mainAccountNumber, accountNumber = param.accountNumber;
    if ((0,app/* isClient */.C5)()) {
        localStorage.setItem(SECURITIES_ACCOUNT_TYPE, accountType);
        localStorage.setItem(SECURITIES_ACCOUNT_NUMBER, accountNumber);
        localStorage.setItem(SECURITIES_MAIN_ACCOUNT_NUMBER, mainAccountNumber);
    }
}
function getSecuritiesAccountInfo() {
    if ((0,app/* isClient */.C5)()) {
        var accountType = localStorage.getItem(SECURITIES_ACCOUNT_TYPE);
        var accountNumber = localStorage.getItem(SECURITIES_ACCOUNT_NUMBER);
        var mainAccountNumber = localStorage.getItem(SECURITIES_MAIN_ACCOUNT_NUMBER);
        return {
            accountType: accountType,
            accountNumber: accountNumber,
            mainAccountNumber: mainAccountNumber
        };
    }
    return {
        accountType: null,
        accountNumber: null,
        mainAccountNumber: null
    };
}
function switchToVirtualTrading() {
    if ((0,app/* isClient */.C5)()) {
        localStorage.setItem(TRADE_IS_LOGGED_IN, "true");
        localStorage.setItem(TRADING_ACCOUNT_TYPE, "virtual");
        localStorage.setItem(TRADING_BROKER, "virtual");
    }
}
function logoutTrading() {
    var keysToRemove = [
        TRADE_IS_LOGGED_IN,
        TRADING_ACCOUNT_TYPE,
        TRADING_BROKER,
        SECURITIES_ACCESS_TOKEN,
        SECURITIES_REFRESH_TOKEN,
        SECURITIES_ACCOUNT_TYPE,
        SECURITIES_MAIN_ACCOUNT_NUMBER,
        SECURITIES_ACCOUNT_NUMBER,
        LAST_TRADING_ACCOUNT_TYPE, 
    ];
    if ((0,app/* isClient */.C5)()) {
        keysToRemove.forEach(function(key) {
            return localStorage.removeItem(key);
        });
    }
}
/* harmony default export */ var securitiesLocalStorage = ({
    getTradingAccountType: getTradingAccountType,
    getSecuritiesToken: getSecuritiesToken,
    saveSecuritiesToken: saveSecuritiesToken,
    switchToVirtualTrading: switchToVirtualTrading,
    logoutTrading: logoutTrading,
    saveSecuritiesAccountInfo: saveSecuritiesAccountInfo,
    getSecuritiesAccountInfo: getSecuritiesAccountInfo
});


/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

}]);